// isMobile from https://github.com/kaimallea/isMobile
(function () {var f=/iPhone/i,j=/iPod/i,p=/iPad/i,g=/\bAndroid(?:.+)Mobile\b/i,i=/Android/i,d=/\bAndroid(?:.+)SD4930UR\b/i,e=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,c=/Windows Phone/i,h=/\bWindows(?:.+)ARM\b/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/\b(CriOS|Chrome)(?:.+)Mobile/i,o=/Mobile(?:.+)Firefox\b/i;function b($,a){return $.test(a)}function a($){var a=($=$||("undefined"!=typeof navigator?navigator.userAgent:"")).split("[FBAN");void 0!==a[1]&&($=a[0]),void 0!==(a=$.split("Twitter"))[1]&&($=a[0]);var r={apple:{phone:b(f,$)&&!b(c,$),ipod:b(j,$),tablet:!b(f,$)&&b(p,$)&&!b(c,$),device:(b(f,$)||b(j,$)||b(p,$))&&!b(c,$)},amazon:{phone:b(d,$),tablet:!b(d,$)&&b(e,$),device:b(d,$)||b(e,$)},android:{phone:!b(c,$)&&b(d,$)||!b(c,$)&&b(g,$),tablet:!b(c,$)&&!b(d,$)&&!b(g,$)&&(b(e,$)||b(i,$)),device:!b(c,$)&&(b(d,$)||b(e,$)||b(g,$)||b(i,$))||b(/\bokhttp\b/i,$)},windows:{phone:b(c,$),tablet:b(h,$),device:b(c,$)||b(h,$)},other:{blackberry:b(k,$),blackberry10:b(l,$),opera:b(m,$),firefox:b(o,$),chrome:b(n,$),device:b(k,$)||b(l,$)||b(m,$)||b(o,$)||b(n,$)},any:!1,phone:!1,tablet:!1};return r.any=r.apple.device||r.android.device||r.windows.device||r.other.device,r.phone=r.apple.phone||r.android.phone||r.windows.phone,r.tablet=r.apple.tablet||r.android.tablet||r.windows.tablet,r}window.isMobile=a();})();

(function() {
    // helpers

    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function(searchElement, fromIndex) {

                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                // 1. Let O be ? ToObject(this value).
                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(searchElement, elementK) is true, return true.
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    // c. Increase k by 1.
                    k++;
                }

                // 8. Return false
                return false;
            }
        });
    }

    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function(search, rawPos) {
                var pos = rawPos > 0 ? rawPos|0 : 0;
                return this.substring(pos, pos + search.length) === search;
            }
        });
    }

    Array.prototype.findObj = function(k, v) {
        var a = [];
        for (var i = 0; i < this.length; i++) {
            if (this[i][k] !== undefined &&
                this[i][k].indexOf(v) >= 0) { a.push(this[i]); }
        };
        return a;
    };

    if (!Array.prototype.find) {
        Array.prototype.find = function(t, p) {
            var a = [];
            for (var i = 0; i < this.length; i++) {
                for (key in p) {
                    if (this[i][key] !== undefined) {
                        if (Number.isInteger(p[key])) {
                            if (this[i][key] === p[key]) { a.push(this[i]); }
                        } else {
                            if (this[i][key].indexOf(p[key]) >= 0) { a.push(this[i]); }
                        };
                    };
                };
            };
            if (t == "all") return a;
            else if (t == "first") return a.length > 0 ? a[0] : undefined;
            else if (t == "last") return [a[a.length - 1]];
            throw "Error!";
        };
    }

    String.prototype.contains = function(w) {
        if (w instanceof Array) {
            for (var i = 0; i < w.length; i++) {
                if (this.indexOf(w[i]) >= 0) {
                    return true;
                };
            };
            return false;
        } else {
            if (this.indexOf(w) >= 0) {
                return true;
            };
            return false;
        };
    };

    String.prototype.encodeHTML = function() {
        return this.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };

    String.prototype.decodeHTML = function() {
        return this.replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"');
    };



    jQuery(function($) {

        var menuBinds, showProductActions, collectionSort, productSlideshow, productTabs, quantityBox, shippingRates, accountEvents, css3Animations, mobileMenu, tryItFree, variantImages, ajaxCart, miniCart, cartVariantChange, quickBuy, collectionProductVariantChange, updateInCart, updateQtyInCart, discountCode, updateQtyInMiniCart, removeItemInMiniCart;

        getCookie = function(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return false;
        }

        setCookie = function(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires;
        }

        getQueryVariable = function(variable) {
            var query = window.location.search.substring(1),
                vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return decodeURIComponent(pair[1]); }
            }
            return (false);
        }

        discountCode = function(code) {
            var $discountTextElem = $('.discount-code-elem'),
                discountSet = (!!sessionStorage.getItem("discount") && sessionStorage.getItem("discount").length != 0),
                init = function() {
                    if (typeof code !== 'undefined'){
                        sessionStorage.setItem('discount',code);
                        discountSet = true;

                    } else if (!!getQueryVariable('discount')) {
                        code = getQueryVariable('discount');
                        discountSet = true;
                    } else {
                        code = sessionStorage.getItem("discount");
                    }

                    window.Theme.promoData.forEach((item, i) => {
                      if (!!item.requireCodeMatch && code == item.requireCodeMatch && item.enableBogo == false){
                        sessionStorage.removeItem('discount');
                        discountSet = false;
                        code == '';
                      }
                    });


                    if ((!!code || code === '') && Theme.template.contains('cart')){
                        document.getElementById('cartform').action = "/cart?discount=" + code;
                    }

                    if (discountSet) {
                      $('.discount-bar').html('Discount code <strong>' + code + '</strong> applied at checkout.');
                      $('.cart-savings-total').remove();
                      $('body').addClass('discount-set discount-message-set');
                    }
                };

            init();
        }
        discountCode();

        menuBinds = function() {
            $(".menu-item").bind("mouseenter mouseleave", function() {
                $(this).find(".nav-dropdown").fadeToggle(200);
            });
        };
        // menuBinds();

        // PRODUCT FORM "select-change"
        showProductActions = function() {
            $(document).on("change", "select[name='id']", function() {
                // push params
                // history.pushState(false, false, window.location.pathname + '?variant=' + $(this).val());
                var $actions = $(this).parents('form'),
                    price = $(this).find("option:selected").attr("data-price"),
                    oldPrice = $(this).find("option:selected").attr("data-old-price"),
                    cartMessage = $(this).find("option:selected").attr("data-cart-message"),
                    available = eval($(this).find("option:selected").attr("data-available")),
                    internal_id = $(this).find("option:selected").attr("data-internal-id"),
                    formatCurrency = function(total) {
                        var neg = false;
                        if (total < 0) {
                            neg = true;
                            total = Math.abs(total);
                        }
                        return (neg ? "-$" : '$') + parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
                    };

                if ($(this).val() == "") {
                    $actions.slideUp(200);
                } else {
                    var price_text = price;

                    if (!!oldPrice) {
                        price_text = '<span class="was-price">' + oldPrice + '</span> ' + price_text;
                    }

                    if (Theme.template.contains('product')) {
                        price_text = "<span class='label'>price: </span>" + price_text;
                    }

                    $actions.find(".amount").html(price_text);
                    $actions.find('#internal_id').val(internal_id);

                    if (!available) {
                        $actions.find('button[type="submit"]').attr('disabled','disabled').text(cartMessage);
                        //$actions.find('button[type="submit"]').attr('disabled','disabled').text(cartMessage + ' | ' + price_text);
                        $actions.find('input').attr('disabled','disabled')
                    } else {
                        $actions.find('button[type="submit"]').prop('disabled',false).text(cartMessage);
                        $actions.find('input').prop('disabled',false)
                    };
                    $actions.slideDown(200);
                };
            });
            // form change
            $("select[name='id']").trigger('change');
        };
        showProductActions();

        collectionSort = function() {
            var select = $("select[name='orderby']");
            select.find('option[value="' + Theme.collection.sort + '"]').attr("selected", "selected");
            select.change(function() {
                window.location = "?sort_by=" + $(this).val() + "#sort-by";
            });
        };

        if (Theme.template.contains(["collection", "search", "product"])) {
            collectionSort();
        };

        productSlideshow = function() {

            sliderMain      = $('.product-slideshow .slides');
            sliderThumbs    = $('.product-thumbs .slides');

            $(window).resize(function() {
                var current = sliderThumbs.slick('slickCurrentSlide');
                sliderThumbs.slick('slickGoTo', current);
            });


            // TODO fix arrows in future:
            // Probably need to set all arrows here to false,
            // create html arrows and set slider to use those instead of dynamic ones.
            // Arrows will sit in thumbs section so they can be properly positioned
            // and not disappear when thumbs fewer than slidestoShow
            // -Austin 9-27-19

            sliderThumbs.slick({
                slidesToShow:   3,
                slidesToScroll: 1,
                asNavFor:       sliderMain,
                arrows:         false,
                // arrows:         true,
                focusOnSelect:  true,
                infinite:       true,
                dots:           false,
                useTransform:   true,
                centerMode:     true,
                responsive: [
                    {
                        breakpoint: 1060,
                        settings: {
                          slidesToShow:   3,
                          slidesToScroll: 1,
                          arrows:         false,
                          focusOnSelect:  true,
                          infinite:       true,
                          dots:           false,
                          useTransform:   true,
                          centerMode:     true,
                        }
                    },
                    {
                        breakpoint: 749,
                        settings: {
                          slidesToShow:   5,
                          slidesToScroll: 1,
                          arrows:         false,
                          focusOnSelect:  true,
                          infinite:       true,
                          dots:           false,
                          useTransform:   true,
                          centerMode:     true,
                        }
                    },
                    // {
                    //     breakpoint: 660,
                    //     settings: {
                    //       slidesToShow:   3,
                    //       slidesToScroll: 1,
                    //       arrows:         false,
                    //       focusOnSelect:  true,
                    //       infinite:       true,
                    //       dots:           false,
                    //       useTransform:   true,
                    //       centerMode:     true,
                    //     }
                    // },
                    {
                        breakpoint: 540,
                        settings: {
                          slidesToShow:  3,
                          slidesToScroll: 1,
                          arrows:         false,
                          focusOnSelect:  true,
                          infinite:       true,
                          dots:           false,
                          useTransform:   true,
                          centerMode:     true,

                        }
                    }
                ]
            });
            sliderMain.slick({
                fade:           true,
                slidesToShow:   1,
                slidesToScroll: 1,
                focusOnSelect:  false,
                arrows:         true,
                // arrows:         false,
                infinite:       true,
                dots:           false,
                asNavFor:       sliderThumbs
            });

            // $('.product-thumbs .slides').on('beforeChange',function(i,j,k,l){
            //   $('.product-slideshow .slides').slick('slickPause');
            //
            //   console.log(i,j,k,l);
            // });
            // $('.product-thumbs .thumb').on('mouseenter',function(e) {
            //   $('.product-slideshow .slides').slick('slickPause');
            //     $('.product-slideshow .slides').slick(
            //       'slickGoTo',
            //       $(this).closest('.slick-slide').data('slick-index')
            //     );
            // });

            clearInt = false;

            $('.tooltip').tooltipster({
                theme: "tooltipster-noir"
            });

            sliderMain.magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        };

        // if (Theme.template.contains("product")) {
        //     productSlideshow();
        // };

        productTabs = function() {
            var headings = $('.tabs > li > a'),
                body = $('.panel.entry-content');
            headings.bind("click", function() {
                var target = $(this).attr("href");
                headings.parent().removeClass("active");
                body.removeClass("active").hide();
                $(this).parent().addClass("active");
                $(target).addClass("active").show();
                return false;
            });
        };
        if (Theme.template.contains("product")) {
            productTabs();
        };

        quantityBox = function() {
            var minus = '.quantity .minus',
            plus = '.quantity .plus',
            buttonClick = function(e) {
                var current = parseInt($(this).closest('[data-multiplier]').find('.qty').val()),
                $box = $(this).closest('[data-multiplier]'),
                multiplier = Number($box.data("multiplier")),
                minimum = Number($box.find('input.input-text.qty').attr('min')),
                maximum = typeof $box.find('input.input-text.qty').attr('max') == 'undefined' ? 100 :  Number($box.find('input.input-text.qty').attr('max'));

                if ($(this).val() === "-") {
                    $(this).next().val(Math.max(...[current - multiplier, minimum])).trigger('change');
                } else {
                    $(this).prev().val(Math.min(...[current + multiplier, maximum])).trigger('change');
                }

                if (Theme.template !== null && Theme.template === "cart") {
                    var $amountElem = $(this).closest('.cart_item').find('.product-subtotal .amount'),
                        price = 100 * $(this).closest('.cart_item').find('.product-price .amount').text().replace('$', '').replace(',', '');
                    $amountElem.html(Shopify.formatMoney(price * $box.find('.qty').val(), Shopify.money_format));
                }
            };

            $(document).on('click',minus,buttonClick);
            $(document).on('click',plus,buttonClick);

        };
        quantityBox();

        maxQuantity = function(items){
          var modifyAdds = function(maxObj){
            var maxAdd = maxObj.max_quantity;
            items.forEach(function(i){
              if(maxObj.max_id == i.product_id){
                maxAdd = maxAdd - i.quantity;
              }
            }),
            modifyInputs = function(id,max){
              var $form = $('form[data-productid="' + id + '"]'),
              $quickBuy = $('.product-small[data-id="' + id + '"]');

              if ($form.length > 0){
                if (max <= 0){
                  $form.find('.quantity input').attr('disabled','disabled');
                  $form.find('button[type="submit"]').attr('disabled','disabled');
                } else {
                  $form.find('.input-text.qty').attr('max',max);
                }
              }

              if ($quickBuy.length > 0){
                if (max <= 0){
                  $quickBuy.find('.add_to_cart_button').attr('disabled','disabled');
                }
              }

            };
            if (maxAdd !== maxObj.max_quantity){
              modifyInputs(maxObj.max_id,maxAdd);
            }
          },
          init = function(items){
            if (Theme.inventoryMax.length > 0 && items.length > 0){
              Theme.inventoryMax.forEach(modifyAdds);
            }
          };

          if (typeof items == 'undefined'){
            $.getJSON('/cart', function(response) {
                maxQuantity(response.items);
            }, this);
          } else {
            init(items);
          }


        };
        maxQuantity(window.Theme.cart.items);

        shippingRates = (function() {
            function shippingRates() {
                this.endpoint = "/cart/shipping_rates.json";
                this.trigger = $(".shipping-calculator-button");
                this.domContainer = $(".shipping-calculator");
                this.domSubmit = this.domContainer.find("button");
                this.domCountry = $("select[name='address[country]']");
                this.domProvince = $("select[name='address[province]']").hide();
                this.domZip = $("input[name='address[zip]']");
                this.domPrice = $(".cart-total-amount");
                this.eventListeners();
            };

            shippingRates.prototype.eventListeners = function() {
                var _this = this;
                _this.trigger.bind("click", function() {
                    _this.domContainer.slideToggle(200);
                    return false;
                });
                _this.domCountry.bind("change", function() {
                    _this.domProvince.html("");
                    var provinces = eval(_this.domCountry.find("option:selected").attr("data-provinces"));
                    if (provinces.length) {
                        _this.updateProvinces(provinces);
                    } else {
                        _this.domProvince.fadeOut(200);
                    };
                });
                _this.domCountry.trigger("change");
                _this.domSubmit.bind("click", function() {
                    _this.domPrice.html(Shopify.formatMoney(Theme.cart.total_price, Shopify.money_format));
                    $('.rates-error').remove();
                    var address = _this.buildAddress(
                        _this.domCountry.val(),
                        _this.domProvince.val(),
                        _this.domZip.val()
                    );
                    _this.domContainer.css("opacity", ".5");
                    _this.httpRequest(address);
                });
            };

            shippingRates.prototype.updateProvinces = function(provinces) {
                for (var i = 0; i < provinces.length; i++) {
                    var markup = "<option value='" + provinces[i][0] + "'>" + provinces[i][0] + "</option>";
                    this.domProvince.append(markup);
                };
                this.domProvince.fadeIn(200);
            };

            shippingRates.prototype.httpRequest = function(address) {
                var _this = this;
                $.ajax({
                    url: _this.endpoint,
                    type: "post",
                    data: address,
                    success: function(json) {
                        var rates = json.shipping_rates[0];
                        _this.updateCartPrice(parseInt(rates.price.replace(/\./, "")));
                    },
                    error: function(response) {
                        _this.onError(JSON.parse(response.responseText));
                    }
                }).always(function() {
                    _this.domContainer.css("opacity", "1");
                });
            };

            shippingRates.prototype.buildAddress = function(c, p, z) {
                return {
                    shipping_address: { country: c, province: p, zip: z }
                };
            };

            shippingRates.prototype.updateCartPrice = function(price) {
                var updated = Shopify.formatMoney(Theme.cart.total_price + price, Shopify.money_format);
                this.domPrice.html(updated);
                $('.cart-total-amount').append(' <span>(with shipping)</span>');
            };

            shippingRates.prototype.onError = function(object) {
                var _this = this;
                $.each(object, function(a, b) {
                    _this.domContainer.append("<p class='rates-error'>" + a + " " + b[0] + "</p>");
                });
            };

            return shippingRates;
        }());

        if (Theme.template.contains("cart")) {
            new shippingRates();
        };

        accountEvents = function() {
            function showRecoverForm() {
                var login = $("#login-form"),
                    recover = $("#recover-form");
                $(".lost_password").bind("click", function() {
                    login.toggle();
                    recover.toggle();
                    return false;
                });
                if (window.location.hash == '#recover') {
                    login.toggle();
                    recover.toggle();
                }
            };

            showRecoverForm();
        };

        if (Theme.template.contains("customers")) {
            accountEvents();
        };

        css3Animations = function() {
            $("html").attr("data-useragent", navigator.userAgent);
        };

        css3Animations();

        scrollListener = (function() {
            function scrollListener() {
                this.targets = $(".scroll-animate");
                this.diff = 1000;
                this.eventListeners();
            };

            scrollListener.prototype.eventListeners = function() {
                var _this = this,
                    Ypos = window.pageYOffset + _this.diff;
                _this.targets.each(function() {
                    var delay = eval($(this).attr("data-delay"));
                    _this.trigger(Ypos, $(this), delay);
                });
                $(window).on('scroll', function() {
                    var Ypos = window.pageYOffset + _this.diff;
                    _this.targets.each(function() {
                        var delay = eval($(this).attr("data-delay"));
                        _this.trigger(Ypos, $(this), delay);
                    });
                });
            };

            scrollListener.prototype.trigger = function(Ypos, el, delay) {
                var _this = this,
                    elYpos = el.offset().top;
                if (Ypos > elYpos) {
                    setTimeout(function() {
                        _this.animate(el);
                    }, delay);
                };
            };

            scrollListener.prototype.animate = function(el) {
                var effect = el.attr("data-animate");
                el.addClass("animated " + effect + "");
            };

            return scrollListener;
        }());

        if (Theme.template.contains("page.how-it-works") || Theme.template.contains("page.its-only-natural") || Theme.template.contains("page.story-of-poo")) {
          new scrollListener();
        }

        mobileMenu = function() {
            var open = $('a[href="#jPanelMenu"]'),
                close = $('.container_a'),
                a = $('.container_a'),
                b = $('.container_b'),
                c = $('.container_c'),
                enabled = false,
                openMenu = function() {
                    a.addClass('mfp-s-ready mfp-bg');
                    b.addClass('mfp-ready mfp-wrap');
                    //c.addClass('mfp-container');
                    $('#jPanelMenu').removeClass("mfp-hide");
                    enabled = true;
                },
                closeMenu = function() {
                    a.removeClass('mfp-s-ready mfp-bg');
                    b.removeClass('mfp-ready mfp-wrap');
                    //c.removeClass('mfp-container');
                    $('#jPanelMenu').addClass("mfp-hide");
                    enabled = false;
                };


            open.bind('click', function() {
                if (enabled == false) {
                    openMenu();
                } else {
                    closeMenu();
                }
                return false;
            });
            close.bind('click', function() {
                if (enabled == true) {
                    closeMenu();
                }
            });
            $('.sub-menu').click(function() {
                $(this).parent().toggleClass("open");
            });
        };
        // mobileMenu();

        variantImages = function() {
            $(document).on("change", "select[name='id']", function() {
                // console.log("VARIANT CHANGE");
                var variant_image = $(this).find('option:selected').data('image');
                if (variant_image !== undefined) {
                    // console.log(variant_image)
                    //var image_in_slideshow = $('.product-slideshow img[src="'+ variant_image +'"]');
                    // var $image_in_slideshow = $('.product-thumbs').find('img[src="' + variant_image + '"]');
                    var $image_in_slideshow = $('.product-thumbs').find('img[src="' + variant_image + '"]').closest('.slick-slide');
                    // console.log($.isNumeric($image_in_slideshow[0]))

                    if ($image_in_slideshow.length > 0) {
                        for (i = 0; i < $image_in_slideshow.length; i++) {
                            slideData = $($image_in_slideshow[i]).data('slick-index');
                            console.log(slideData)
                            if ( slideData > 0 ) {
                                // thisSlide = $image_in_slideshow[i].data();
                                $('.product-slideshow .slides').slick('slickGoTo', slideData);
                                break;
                            }
                        }

                        /*var current_slide = $('.product-slideshow').data('flexslider').currentSlide;
                        var new_slide_index = image_in_slideshow.parents('li:not(.clone)').index();*/

                        // $image_in_slideshow.parent('li').trigger('click');
                        // $image_in_slideshow.parent('.slick-slide').trigger('click');
                        // $image_in_slideshow.click();
                        // $image_in_slideshow.trigger('click');

                    };
                };
            });
        };


        if (Theme.template.contains("product")) {
            variantImages();
        };

        miniCart = function(){
          var $miniCart = $('#mini-cart'),//.addClass('openCart'),
          $miniCartContainer = $miniCart.find('.mini-cart'),
          $cartList = $miniCart.find('.cart_list'),
          $cartAd = $miniCart.find('.cart_ad'),
          $cartCheckout = $miniCart.find('.footer-checkout'),
          $cartShipping = $cartAd.find('.shipping-message'),
          hasVariant = function(variant, cartResponse) {
            retVariant = false;
              cartResponse.items.forEach(function(item) {

                  if (item.variant_id == variant) {
                      retVariant = true;
                  }

              });
              return retVariant;

          },
          getFormattedLine = function(item){
            // haven't figured out where o is coming from yet
            // had to add 'typeof o !== undefined' to fix my cart functions.
            // none of the below logs have fired for me so it's hard to track down issue. austin / 9-27-19
            if ( typeof o !== 'undefined' ) {
                console.log(o)
                console.log(o.id)
                console.log(item.product_id)
                if(typeof window.Theme.url_overrides.find(o => o.id === item.product_id) !== 'undefined'){
                    item.url = window.Theme.url_overrides.find(o => o.id === item.product_id).override;
                }
            }

            var $r = $('<div class="mini-cart-line"></div>'),
            $i = $('<img src="' + item.image + '">'),
            $p = $('<h2><a href="' + item.url + '">' + item.product_title.replace('  Auto renew','') + '</a></h2>');
            if (item.url == ''){
              $p = $('<h2>' + item.product_title.replace('  Auto renew','') + '</h2>');
            }
            var $t = $('<div class="line-info"></div>').append($p),
            $m = $('<div class="line-total"><div>' + Shopify.formatMoney(item.line_price,Shopify.money_format) + '</div></div>'),
            $c = $('<div class="line-remove"><a class="icon-close remove-mini-cart-item" data-id="' + item.variant_id + '" data-key="' + item.key + '"></a></div>'),
            $q = $('<div class="quantity buttons_added" data-multiplier="1">'),
            selectNovariantText = function(id){
              var ret = false;

              if (typeof window.Theme.novariant_items.find(x => x.id === id) !== 'undefined'){
                if (window.Theme.novariant_items.find(x => x.id === id).cart !== ''){
                  ret = window.Theme.novariant_items.find(x => x.id === id).cart;
                } else if (window.Theme.novariant_items.find(x => x.id === id).override !== ''){
                  ret = window.Theme.novariant_items.find(x => x.id === id).override;
                } else if (window.Theme.novariant_items.find(x => x.id === id).intro !== ''){
                  ret = window.Theme.novariant_items.find(x => x.id === id).intro;
                }
              }

              return ret;

            },
            max = typeof Theme.inventoryMax.find(x => x.handle === item.handle) !== 'undefined' ? Theme.inventoryMax.find(x => x.handle === item.handle).max_quantity : false,
            max_txt = !!max ? ' max="' + max + '"' : '';

            $q.append('<input type="button" value="-" class="minus">');
            $q.append('<input type="number" min="0" ' + max_txt + ' id="updates_' + item.variant_id + '" name="updates[]" data-variant-id="' + item.variant_id + '" data-load-value="' + item.quantity + '" data-line-number="0" value="' + item.quantity + '" class="input-text qty text" size="4" data-line-key="' + item.key + '">');
            $q.append('<input type="button" value="+" class="plus">');

            if (item.line_price == 0){
              $m = $('<div class="line-total"><div>&nbsp;FREE</div></div>');
              $q.find('input').attr('disabled','disabled');
            }
            if (item.quantity > 1){
              $p.append(' <span class="quantity">x ' + item.quantity + '</span>');
            }

            if (!!item.variant_title){
              $t.append('<p class="smaller-font">' + item.variant_title + '</p>');
            } else if (selectNovariantText(item.product_id) !== false){
              $t.append('<p class="smaller-font">' + selectNovariantText(item.product_id) + '</p>');
            } else if(typeof item.properties.shipping_interval_frequency != 'undefined'){
              switch (item.product_id){
                case 9179154691:
                case 2150698451041:
                  if (item.properties.shipping_interval_frequency > 1){
                    $t.append('<p class="smaller-font">2oz + FREE tester<br> &mdash;&nbsp;' + item.properties.shipping_interval_frequency + '&nbsp;months</p>');
                  } else {
                    $t.append('<p class="smaller-font">2oz + FREE tester<br> &mdash;&nbsp;' + item.properties.shipping_interval_frequency + '&nbsp;month</p>');
                  }
                  break;
                case 1931251875937:
                case 2150699401313:
                  if (item.properties.shipping_interval_frequency > 1){
                    $t.append('<p class="smaller-font">4oz + 2oz + 2 FREE testers<br> &mdash;&nbsp;' + item.properties.shipping_interval_frequency + '&nbsp;months</p>');
                  } else {
                    $t.append('<p class="smaller-font">4oz + 2oz + 2 FREE testers<br> &mdash;&nbsp;' + item.properties.shipping_interval_frequency + '&nbsp;month</p>');
                  }
                  break;
                case 2113657831521:
                case 2150698942561:
                  if (item.properties.shipping_interval_frequency > 1){
                    $t.append('<p class="smaller-font">4oz + 3 x 2oz + 2 FREE testers<br> &mdash;&nbsp;' + item.properties.shipping_interval_frequency + '&nbsp;months</p>');
                  } else {
                    $t.append('<p class="smaller-font">4oz + 3 x 2oz + 2 FREE testers<br> &mdash;&nbsp;' + item.properties.shipping_interval_frequency + '&nbsp;month</p>');
                  }
                  break;

                default:
                  break;
              }
            }

            $r.append($i);
            $r.append($t);
            // $r.append('<div>x ' + item.quantity + '</div>');

            if (item.original_line_price > item.line_price){
              $m.prepend('<div class="strike">' + Shopify.formatMoney(item.original_line_price,Shopify.money_format) + '</div>');
              if(item.discounts.length > 0 && item.discounts[0].title.length > 0){
                $t.append('<div class="bundle-tag">' + item.discounts[0].title + '</div>');
              }

            } else if (item.compare_at_price > item.line_price){
              $m.prepend('<div class="strike">' + Shopify.formatMoney(item.compare_at_price,Shopify.money_format) + '</div>');
            } else if (item.title.indexOf('Auto renew') > -1){
              switch (item.price) {
                case 3995:
                $m.prepend('<div class="strike">$54.95</div>');
                  break;
                case 2495:
                $m.prepend('<div class="strike">$34.95</div>');
                  break;
                case 995:
                $m.prepend('<div class="strike">$14.95</div>');
                  break;
                default:

              }
            }

            if(item.sku == 'PP-001-BUL'){
                $t.append('<div class="bundle-tag">Patience young pooper… Discount applied in checkout.</div>');
            }

            $t.append($q);

            $r.append($m);
            $r.append($c);

            return $r;
          },
          updateLineItems = function(cart){
            $cartList.html('');
            if (cart.items.length == 0){
              $cartList.html('<p class="empty">' + $miniCart.data('empty-message') + '</p>');
            } else {
              cart.items.forEach(function(i){
                $cartList.append(getFormattedLine(i));
              });
            }
          },
          updateShippingMessage = function(cart){
            if (!!window.Theme.cart_ad.cart_ad_shipping_enabled){
              if(cart.total_price == 0){
                $cartShipping.html('<span class=\"\">Free US Shipping with $19.90</span>');
              } else {
                if (cart.total_price < 1990) {
                  $cartShipping.html("<span class=\"\">You&rsquo;re " + Shopify.formatMoney(1990 - cart.total_price,Shopify.money_format) + " away from free shipping</span>");
                } else {
                  $cartShipping.html('');
                }
              }
            }
          },
          updateCheckoutMessage = function(cart){
            var getFormattedTotal = function(cart){
              var $r = $('<strong>Subtotal</strong> <span class="line-total">' + Shopify.formatMoney(cart.total_price) + '</span> <div class="aligncenter text-center discount-code-elem" style="margin-top: 1em;font-family: proxima-nova;font-size: 14px;font-weight: 700;"></div><div class="checkout" action="/cart" method="post"><button type="submit" name="checkout" class="button">Proceed to Checkout</button></div>');

              return $r;
            },
            getFormattedDiscount = function(cart){
              var $r = $('<p class="mini-cart-discount"></p>'),
              discount_total = 0;
              // console.log('cart',cart)
              cart.items.forEach(function(i){

                if (i.title.indexOf('Auto renew') > -1){
                  switch (i.price) {
                    case 3995:
                    discount_total += 1500;
                      break;
                    case 2495:
                    discount_total += 1000
                      break;
                    case 995:
                    discount_total += 500
                      break;
                    default:
                  }
                } else if (typeof i.compare_at_price !== 'undefined') {
                  discount_total += (Math.max(i.original_line_price, i.compare_at_price) - i.line_price);
                } else {
                  discount_total += i.original_line_price - i.line_price;
                }

              });


              if (discount_total > 0){
                $r.html('<div class="discount-data">' + Shopify.formatMoney(discount_total) + ' Savings!</div>');
              }

              return $r;
            };

            if(cart.item_count == 0){
              $cartCheckout.html('');
            } else {
              $cartCheckout.html(getFormattedDiscount(cart).append(getFormattedTotal(cart)));
            }

          },
          updateCount = function(count){
            $('.cart-icon strong').text(count);
          },
          updateAd = function(cart){
            var cart_ad = window.Theme.cart_ad,
            createAd = function(){
              var $img = $('<img src="' + cart_ad.cart_ad_small + '">'),
              $link = $('<a href = "' + cart_ad.cart_ad_link + cart_ad.cart_ad_hash + '" class="mini-cart-ad">');

              $cartAd = $('<div class="cart_ad"></div>');
              $cartShipping = $('<span class="shipping_message"></span>');

              $cartAd.append($cartShipping);

              if (cart_ad.cart_ad_hash_link){
                $link.addClass('hash-link');
              }

              if (!!cart_ad.cart_ad_link || !!cart_ad.cart_ad_hash){
                $link.append($img);
                $cartAd.append($link);
              } else {
                $cartAd.append($img);
              }

              $miniCartContainer.prepend($cartAd);

            },
            showAd = function(){
              if ($cartAd.length == 0){
                createAd();
              }
              $cartAd.removeClass('hide');

            },
            removeAd = function(){
              $cartAd.addClass('hide');
            };
            if (cart_ad.cart_ad_enabled == true){
              if (!hasVariant(cart_ad.cart_ad_variant,cart)){
                showAd();
              } else {
                if ($cartAd.length > 0){
                  removeAd();
                }
              }
            }
          },
          showCart = function(){
            if (typeof window.runOpenCart === 'undefined' && window.runOpenCart !== false){
              $miniCart.addClass('openCart');
              setTimeout(function() { $miniCart.removeClass("openCart"); }, 3000);
            }
          },
          updateData = function(cart){
            var data = {};

            cart.items.forEach(function(i){
              data[i.id] = {
                key: i.key,
                quantity: i.quantity
              }
            });

            $miniCart.data({items: data});
          },
          update = function(peekCart, cart){
            if (typeof peekCart === 'undefined'){
              peekCart = false;
            }
            // console.log('peek ' + peekCart);

            if (typeof cart === 'undefined'){
              $.getJSON('/cart', function(cart){
                update(peekCart,cart);
              });
            } else {
              updateAd(cart);
              updateLineItems(cart);
              updateCheckoutMessage(cart);
              updateShippingMessage(cart);
              updateData(cart);
              // updateFooter(cart);
              updateCount(cart.item_count);
              if (peekCart){
                showCart();
              }
            }
          },
          removeMiniCartItem = function(e){
            e.preventDefault();
            Shopify.removeItem($(e.target).data('key'),function(c){
              if (Theme.template.contains("cart")) {
                window.location.reload(false);
              } else {
                update(false,c);
                tempDiscounts();
              }
            });
          },
          startListeners = function(){
            $(document).on('click','.remove-mini-cart-item',removeMiniCartItem);
          },
          $shippingMessage = $('<div class="footer-checkout"></div>'),
          init = function(){
            update(false,window.Theme.cart);
            startListeners();
            // console.log('init mini cart');
          },
          ret = {
            $miniCart: $miniCart,
            update: update
          };

          init();

          return ret;
        };
        // Theme.minicart = new miniCart();
        // Theme.minicart.eventListeners();

        klaviyoTrack = function(action,item){
          if (action == 'add'){

            var _learnq = _learnq || [];

            if (typeof item === 'undefined'){

              if (typeof window.klaviyoItem == 'undefined'){
                item = window.klaviyoItem;
              }

            }

            _learnq.push(['track', 'Added to Cart', item]);
            console.log(_learnq);
          }
        }

        ajaxCart = function() {
            var onSubmit = function() {
                var $form = $(this);
                if (typeof pintrk === 'function'){
                  pintrk('track', 'addtocart');
                }
                $.ajax({
                    url: '/cart/add.json',
                    type: 'post',
                    dataType: 'json',
                    data: $form.serialize(),
                    success: function(response) {
                        maxQuantity([response]);
                        klaviyoTrack('add');
                        tempDiscounts(function() {
                            if(showVueCart == true) {
                                window.miniCart.refreshCart();
                            }
                        });

                        if (!$('.form-message.success').length){
                          $form.append('<p class="form-message success">' + response.title + ' added&nbsp;to&nbsp;your&nbsp;<a href="/cart">cart</a>.</p>');
                        } else {
                          $form.find('.form-message.success').html(response.title + ' added&nbsp;to&nbsp;your&nbsp;<a href="/cart">cart</a>.</p>');
                        }
                    },
                    error: function(response) {
                        var errors = JSON.parse(response.responseText);
                        if (!$('.form-message.error').length)
                            $form.append('<p class="form-message error">' + errors.errors + '.</p>');
                    }
                });
                return false;
            };

            $('form[action="/cart/add"]').on('submit', onSubmit);
        };
        if (Theme.template.contains("product") || Theme.template.contains("collection") || Theme.template.contains('custom-') || Theme.template.contains('meet-your-match') || Theme.template.contains('theassistant') || Theme.template.contains('poo-love') || Theme.template.contains('school') || Theme.template.contains('how-it-works') ) {
            ajaxCart();
        };

        // new try it free pages
        if ( Theme.template == 'page.try-it-free-sub' || Theme.template == 'collection.back_to_school') {
            $('.tif_add_to_cart').click(function() {
                var variant = $(this).data('variant-id');
                setTimeout(function(){
                    Theme.minicart.update(true);
                }, 1000);
            });
        };

        cartVariantChange = function() {
            var select = $('select[name="cart_variant"]');
            select.bind('change', function() {
                var idToReplace = $(this).data('variant-id');
                var idToAdd = $(this).val();
                var qty = $('#updates_' + idToReplace).val();
                if(idToReplace !== idToAdd){
                    Shopify.removeItem(idToReplace, function(r){
                        Shopify.addItem(idToAdd, qty, function(s){
                            //minicart.update(parseInt(idToAdd));
                            location.reload();
                        });
                    });
                };

            });
        };
        if (Theme.template.contains("cart")) {
            cartVariantChange();
        };

        ajaxRemove = function() {
            var $removeButton = $('.remove-ajax'),
                removeLine = function(line_no) {

                    $.ajax({
                        type: "POST",
                        url: '/cart/change.js',
                        data: {
                            quantity: 0,
                            line: line_no
                        },
                        dataType: 'json',
                        success: function(data) {
                            console.log(data);
                        }
                    });
                },
                removeLines = function(lineArray) {
                    $.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        data: {
                            updates: lineArray
                        },
                        dataType: 'json',
                        success: function(data) {
                            console.log(data);
                            if (Theme.template === 'cart') {
                                window.location.reload();
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                },
                removeItems = function(items) {
                    var updates = {};

                    items.forEach(function(i) {
                        updates[i] = 0;
                    });
                    $.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        data: {
                            updates: updates
                        },
                        dataType: 'json',
                        success: function(data) {
                            console.log(data);
                            if (Theme.template === 'cart') {
                                window.location.reload();
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                },
                removeKey = function(key){

                },
                removeClick = function(e) {
                    var $elem = $(e.currentTarget),
                        var_key = $elem.data('key'),
                        var_id_string = $elem.data('variant-ids'),
                        var_ids = var_id_string.toString().split(','),
                        line_no = $elem.data('line'),
                        $cartForm = $('#cartform'),
                        $cartItem = $cartForm.find('.cart_item'),
                        lineQuantities = [];

                    if (typeof var_key !== 'undefined'){
                      Shopify.removeItem(var_key,function(){
                        if (Theme.template.contains("cart")) {
                            window.location.reload(false);
                        } else {
                          update();
                        }
                      });
                    } else {

                      $cartItem.each(function(i, j) {
                          var $item = $(j),
                              getQuantity = function() {
                                  if ($item.find('.input-text.qty').length > 0) {
                                      return $item.find('.input-text.qty').val();
                                  } else {
                                      return $item.find('input').val();
                                  }
                              },
                              quantity = getQuantity(),
                              id = $item.data('id');

                          if (var_id_string.toString().indexOf(id) >= 0) {
                              lineQuantities.push(0);
                          } else {
                              lineQuantities.push(quantity);
                          }
                      });

                      removeLines(lineQuantities);

                    }
                    // if (typeof var_ids.length === 1){
                    // removeItems(var_ids);
                    e.preventDefault();
                    // }

                },
                init = function() {
                    $removeButton.each(function(i, j) {
                        $(j).on('click', removeClick);
                    });
                };
            init();
        }
        ajaxRemove();

        isSelectOption = function(el) {
            var $this           = el,
                $selectsOnLoad  = $this.find('option:selected'),
                $selectOpt      = $selectsOnLoad.data('variant-title') ? $selectsOnLoad.data('variant-title') : $selectsOnLoad.text(),
                isSelectOpt     = $selectOpt.toLowerCase().indexOf('select option') >= 0,
                $btn            = $this.closest('.quick-buy').find('button'),
                metaInfo        = $this.closest('.product-small').find('.flex-meta');
            // console.log($selectOpt.length && isSelectOpt)
            if ( $selectOpt.length && isSelectOpt ) {
                $btn.text($selectOpt).addClass('hover').prop('disabled', true);
            }

            // console.log( isSelectOpt )

            if ( isSelectOpt  ) {
                // Hide Stars and Price on No 2 Landing Page
                metaInfo.removeClass('active');
            } else {
                // Show Stars and Price on No 2 Landing Page
                metaInfo.addClass('active');
            }
        };

        quickBuy = function() {
            var $btns = $('.quick-buy button'),
                items,
                $selects = $('.quick-buy select'),
                addItem = function(id,internal_id,quantity,$btn){
                    if (typeof pintrk === 'function'){
                        pintrk('track', 'addtocart');
                    }

                    items = [
                        {
                            quantity: quantity,
                            id: id,
                            properties: {
                                'internal_id': internal_id
                            }
                        }
                    ];

                    jQuery.post('/cart/add.js', {
                        items: items,
                        success: function() {
                            setTimeout(function() {
                                console.log('%c QUICKBUY ADD => ' + id, 'background-color: yellow;');

                                if(showVueCart == true) {
                                    window.miniCart.refreshCart();
                                }

                                $btn.html('Added!').addClass('success');
                                setTimeout(function(){ $btn.html('Add To Cart').removeClass('success'); }, 5000);

                                maxQuantity(r.items);
                                tempDiscounts(function() {
                                    if(showVueCart == true) {
                                        window.miniCart.refreshCart();
                                    }
                                });
                            }, 1500);
                        }
                    });
                },
                removeAddItem = function(id,internal_id,quantity,$btn){
                    var removeData = {};
                    removeData[id] = 0;

                    $.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        data: { updates: removeData },
                        dataType: 'json',
                        success: function(r) {
                            addItem(id,internal_id,quantity,$btn);
                        }
                    });
                };

            $selects.each(function () {
                isSelectOption($(this));
            });


            $btns.click(function(e) {
                var $btn = $(this),

                    $selects = $btn.closest('.flex-action').find('select'),

                    qbObj = $btn.parents('.quick-buy').find('*[name="qb-id"]'),
                    id = qbObj.val() + "",
                    internal_id = qbObj.find(':selected').data('internal-id'),
                    qty = parseInt($btn.parents('.quick-buy').find('*[name="qb-qty"]').val()),

                    data = $("#mini-cart").data(),
                    productData = $(this).closest('.product-small').data(),
                    whchSel = (function(){
                        try{
                        return $selects.find('option:selected').data('variant-title').toLowerCase().indexOf('10ml') || -1;
                        }
                        catch(error) {
                        return -1;
                        }
                    })();

                if (!qty) {
                    qty = 1;
                }
                // if (typeof data.items[id] != 'undefined'){
                //     qty += data.items[id].quantity;
                // }
                if(internal_id == null) {
                    internal_id = qbObj.data('internal-id');
                }

                klaviyoTrack('add',{
                    Name: productData.title,
                    ProductID: productData.id,
                    Categories: productData.categories,
                    ImageURL: productData.imageurl,
                    URL: "https://poopourri.com" + productData.url,
                    Brand: productData.brand,
                    Price: productData.price,
                    CompareAtPrice: productData.compareatprice
                });

			    removeAddItem(id,internal_id,qty,$btn);
            });

            $selects.change(function() {
                var $select = $(this),
                    $selected = $select.find('option:selected'),
                    $btn = $select.parents('.quick-buy').find('button'),
                    price = $selected.data('price'),
                    $price = $select.parents('.quick-buy').find('.price .amount'),
                    btnChng = function($selected) {
                      if ($selected.data('available')) {
                        // REDESIGNED - updated button to include variant price
                        $btn.html('Add To Cart' + ' &nbsp;|&nbsp; ' + price).prop('disabled', false).removeClass('hover');
                      } else {
                        $btn.html('Out Of Stock').prop('disabled', true);
                      };
                    }

                $price.html(price);

                btnChng($selected);

                isSelectOption($(this));
            });

        }
        quickBuy();


        collectionProductVariantChange = function() {
            $(document).on('change', 'select[name="qb-id"]', function() {

                var variant_image = $(this).find('option:selected').data('image');
                // console.log("variant_image", variant_image, variant_image.length);
                if (variant_image && variant_image.length) {

                    // When images are connected
                    var $thisPar = $(this).closest('.product-small');
                    var $img = $thisPar.find('.front-image .bg_image:first-of-type');
                    // var $hov = $thisPar.find('.front-image .mini-slider');
                    if ( $img.length ) {
                        $img.css({
                            "background-image": "url('" + variant_image + "')"
                        });
                    }
                    // if ($hov.length) {
                    //     $hov.attr('style', '--mini-slider: url(' + variant_image + ');')
                    // }


                    // When images and form are split on No. 2 Landing
                    var $side_img = $(this).closest('.inner-container.product-block').find('.product-small.no-2-redesigned');
                    // console.log($side_img.length)
                    if ( $side_img.length > 0 ) {
                        var $img_no2 = $side_img.find('.front-image .bg_image:first-of-type');
                        // var $hov_no2 = $side_img.find('.front-image .mini-slider');
                        var arryID = $side_img.data('variant-overrides');
                        var thisInd = $(this).prop('selectedIndex');

                        frstSel = $(this).children().first('option').attr('val');
                        if ( typeof frstSel === 'undefined' ) {
                            thisInd--; //remove one from index so variants still align
                            // console.log(thisInd)
                        }

                        // Check for normal changes first
                        if ($img_no2.length && !arryID[thisInd].var_img_wide.length) {
                            $img_no2.css({
                                "background-image": "url('" + variant_image + "')"
                            });
                        }

                        // Check for overrides
                        if ( arryID[thisInd].var_size.length ) {
                            var $size_no2 = $thisPar.find('.size-info');
                            var rplc_size = arryID[thisInd].var_size;
                            $size_no2.text(rplc_size)
                        }
                        if ( $img_no2.length && arryID[thisInd].var_img_wide.length ) {
                            var img = new Image();
                            img.src = arryID[thisInd].var_img_wide;
                            $img_no2.parent().fadeOut(100, function () {
                                $img_no2.css({
                                    "background-image": "url('" + arryID[thisInd].var_img_wide + "')"
                                });
                            }).delay(600).fadeIn(300)
                        }
                    }

                    // When Double Wide
                    var $dblWide_img = $(this).closest('.product-small.wide:not(.no-2-redesigned)');
                    // console.log($dblWide_img)
                    if ( $dblWide_img.length > 0  ) {
                        var $img_wide = $dblWide_img.find('.front-image .bg_image:first-of-type');
                        var arryID = $dblWide_img.data('variant-overrides');
                        var thisInd = $(this).prop('selectedIndex');

                        frstSel = $(this).children().first('option').attr('value');



                        if ( typeof frstSel === 'undefined' ) {
                            thisInd--; //remove one from index so variants still align
                            console.log(thisInd)
                        }
                        noOvrrde = true;
                        if ( !!arryID && arryID[thisInd].var_img_wide.length !== '0'  ) {
                             noOvrrde = false;
                        }

                        // Check for normal changes first
                        if ($img_wide.length && noOvrrde ) {
                            $img_wide.css({
                                "background-image": "url('" + variant_image + "')"
                            });
                        }

                        // // Check for overrides
                        if ( arryID[thisInd].var_size.length ) {
                            var $size_no2 = $thisPar.find('.size-info');
                            var rplc_size = arryID[thisInd].var_size;
                            $size_no2.text(rplc_size)
                        }
                        if ( $img_wide.length && !noOvrrde ) {

                            var img = new Image();
                            img.src = arryID[thisInd].var_img_wide;

                            $img_wide.css({
                                "background-image": "url('" + arryID[thisInd].var_img_wide + "')"
                            });
                        }
                    }
                }
            });
        };
        collectionProductVariantChange();

        updateQtyInCart = function(){
          var qtyBox = 'input[name="updates[]"]';
          qtyChange = function(){

            var elem = this,
            $elem = $(elem),
            line = parseInt($(elem).data('line-number')) + 1,
            qty = $elem.val(),
            diff = qty - $(elem).data('loadValue'),
            key = $elem.data('line-key');

              window.Shopify.queue.push({action:'change',data:{
                id: key,
                quantity: qty
              }});

            if (!window.Shopify.inQueue){
              window.Shopify.moveAlong(function(){
                lineNumber = $(elem).data('line-number');
                
                $.getJSON('/cart.js',function(data){
                  console.log('cartjs called');
                  var toReload = function(){
                    var retItems = data.items,
                    loadItems = window.Theme.cart.items,
                    lineCountEqual = function(){
                      if (retItems.length == loadItems.length){
                        return true;
                      }
                      return false;
                    },
                    currentItemDiscountUnchanged = function(){
                      var ret = true;
                      retItems.forEach(function(i,j){
                        if (typeof loadItems[j] === 'undefined'){
                          ret = false;
                        } else {
                          if (typeof loadItems[j].discounts == 'undefined'){
                            loadItems[j].discounts = [];
                          }
                          if (i.discounts.length != loadItems[j].discounts.length){
                            ret = false;
                          }
                        }
                      });
                      return ret;
                    },
                    otherItemsPriceUnchanged = function(){
                      var ret = true;
                      retItems.forEach(function(i,j){
                        if (j != lineNumber){
                          if(i.line_price != loadItems[j].line_price){
                            ret = false;
                          }
                        }
                      });
                      return ret;
                    };

                    if (lineCountEqual() && otherItemsPriceUnchanged() && currentItemDiscountUnchanged()){
                      return false
                    }
                  };
                  
                });

              });
            }
          };

          $(document).on('change', qtyBox, qtyChange);

        };
        updateQtyInCart();

        window.Shopify.inQueue = false;
        window.Shopify.queue = [];
        window.Shopify.moveAlong = function(callback) {
            window.Shopify.inQueue = true;
            if (typeof callback === 'undefined') {
                callback = false;
            }
            if (window.Shopify.queue.length) {
                var request = window.Shopify.queue.shift();

                if (request.action === 'update') {
                    $.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        data: request.data,
                        dataType: 'json',
                        success: function() {
                            window.Shopify.moveAlong(callback);
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                } else if (request.action === 'change') {
                    $.ajax({
                        type: "POST",
                        url: '/cart/change.js',
                        data: request.data,
                        dataType: 'json',
                        success: function() {
                            window.Shopify.moveAlong(callback);
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                } else {
                    $.ajax({
                        type: "POST",
                        url: '/cart/add.js',
                        data: request.data,
                        dataType: 'json',
                        success: function() {
                            window.Shopify.moveAlong(callback);
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                }

            } else {
                window.Shopify.inQueue = false;
                if (callback !== false) {
                    callback();
                }
                tempDiscounts();
            }
        };

        tempDiscounts = function(callback,firstLoad) {
            var promo = false,
                // date = new Date(),
                date = (function() {
                    var fDate = getQueryVariable('forceDate');
                    if (!!fDate) {
                        return new Date(fDate);
                    } else {
                        return new Date();
                    }
                })(),
                displayPromo = function(promo) {
                    var $callout = $('.top-bar-callout'),
                        $bar = $('.discount-bar');

                    if (typeof promo.ticker !== 'undefined') {
                        $callout.html(promo.ticker.message);
                        if (typeof promo.ticker.href !== 'undefined') {
                            $callout.attr('href', promo.ticker.href);
                        }
                    }
                    if (typeof promo.promoBar !== 'undefined' && typeof sessionStorage.getItem("promo") !== undefined && !!sessionStorage.getItem("promo")) {
                        $bar.html(sessionStorage.getItem("promo"));
                        $('body').addClass('discount-set discount-message-set');
                    }

                },
                makeCallback = function() {
                    if (typeof callback !== 'undefined') {
                        callback();
                    } else {
                        if (Theme.template.contains("cart")) {
                            window.location.reload();
                        } else {
                            // Theme.minicart.update(true);
                        }
                    }
                },
                runPromo = function(promo) {
                    promo.action(promo);
                },
                isCurrent = function(promoDate) {
                    // var d = new Date(),
                    //   estOffset = 5 - d.getTimezoneOffset()/60;

                    // date.setHours(date.getHours() - estOffset);
                    date.setHours(date.getHours());

                    if (date > promoDate.start) {
                        if (typeof promoDate.end !== 'undefined' && promoDate.end > date) {
                            return true;
                        }
                    }

                    return false;
                },
                runCurrent = function(promo) {
                    var hasCurrent = false;

                    if (typeof promo.date !== 'undefined') {

                        if (isCurrent(promo.date)) {
                            hasCurrent = true;
                            displayPromo(promo);
                            promo.action(promo);
                        } else {
                            if (sessionStorage.getItem("promo") !== undefined && !!sessionStorage.getItem("promo") && sessionStorage.getItem("promo") == promo.promoBar) {
                                sessionStorage.removeItem("promo");
                            }
                        }
                    } else {
                        hasCurrent = true;
                        promo.action(promo);
                    }
                    if (!hasCurrent){
                      makeCallback();
                    }
                },
                setPromo = function(promo) {
                    // if (getCookie('hp') !== promo.cookie){
                    //   displayPromo(promo);
                    //   setCookie('hp',promo.cookie,2);
                    // }
                    if (promo.length > 0) {
                        promo.forEach(runCurrent);
                    } else {
                        makeCallback();
                    }
                },
                addItem = function(item, doCallback) {
                    $.ajax({
                        type: "POST",
                        url: '/cart/add.js',
                        data: item,
                        dataType: 'json',
                        success: function(data) {
                            if(Theme.template.contains("cart")){
                              window.location.reload();
                            } else {
                              if (typeof doCallback == 'undefined' || !!doCallback) {
                                makeCallback();
                              }

                            }
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                },
                removeItem = function(id,c) {
                    updates = {};
                    updates[id] = 0;
                    $.ajax({
                        type: "POST",
                        url: '/cart/update.js',
                        data: { updates: updates },
                        dataType: 'json',
                        success: function(i, j, k) {
                            console.log(i, j, k);
                            if (typeof c == 'undefined'){
                              makeCallback();
                            } else {
                              c();
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log(status);
                            console.log(error);
                        }
                    });
                },
                getVariantCount = function(variant, cartResponse, go){
                  var ret = 0;
                  if (typeof variant == 'number') {
                      variant = {
                          id: variant,
                          quantity: 1,
                          discountProperty: false
                      }
                  }

                  cartResponse.items.forEach(function(item) {

                    if (typeof go !== 'undefined' && !!go){
                      for (var i = 0; i < go.length; i++) {
                        if (go[i].id == item.variant_id){
                          return;
                        }
                      }
                    }

                    if ( (typeof variant.title === 'undefined' || item.title.indexOf(variant.title) > -1) && (typeof variant.id === 'undefined' || item.variant_id == variant.id) && (!variant.discountProperty || (typeof item.properties.Discount !== 'undefined' && item.properties.Discount === variant.discountProperty))
                    ) {
                        ret += item.quantity;
                    }

                  });
                  return ret;
                },
                hasVariant = function(variant, cartResponse) {
                    if (typeof variant == 'number') {
                        variant = {
                            id: variant,
                            quantity: 1,
                            discountProperty: false
                        }
                    }
                    return (getVariantCount(variant,cartResponse) >= variant.quantity);

                },
                hasSubscription = function(response) {
                    var retSubscription = false;

                    response.items.forEach(function(item) {

                        if (item.properties != null && typeof item.properties.subscription_id != 'undefined') {
                            retSubscription = true;
                        }
                    });
                    return retSubscription;
                },
                hasTrialItem = function(response) {
                    var retTrialItem = false;

                    response.items.forEach(function(item) {
                        if (item.product_type === "Free Feature") {
                            retTrialItem = true;
                        }
                    });
                    return retTrialItem;
                },
                cartSize = function(minimum, item, options) {
                    if (typeof options === 'undefined') {
                        options = {
                            allowSubscriptions: true,
                            excludeComboVariant: false
                        };
                    }
                    getCart(function(response) {
                        var added = false,
                            hasFreeTrialItem = false;

                        if (options.allowSubscriptions === true || hasSubscription(response)) {
                            makeCallback();
                            return false;
                        }
                        if (options.excludeComboVariant !== false) {
                            response.items.forEach(function(responseItem) {
                                if (typeof responseItem.variant_id !== 'undefined' && responseItem.variant_id === options.excludeComboVariant) {
                                    hasFreeTrialItem = true;
                                }
                            });

                            if (hasFreeTrialItem) {
                                makeCallback();
                                return false;
                            }
                        }
                        response.items.forEach(function(responseItem) {
                            if (typeof responseItem.variant_id !== 'undefined' && responseItem.variant_id === item.id) {
                                added = true;
                            }
                        });

                        if (!added) {

                            if (response.total_price > minimum && !added) {
                                addItem(item);
                            }

                        } else {
                            makeCallback();
                        }

                    });
                },
                getCart = function(callback) {
                  if (typeof firstLoad == 'undefined'){
                    $.getJSON('/cart', function(response) {
                        callback(response);
                    }, this);
                  } else {
                    callback(window.Theme.cart);
                  }
                },
                bogo = function(bo, go, options) {
                    $.getJSON('/cart', function(response) {
                        var boAdded = 0,
                            goAdded = 0,
                            boQuantity = 1,
                            goQuantity = 1,
                            limit = -1,
                            toAdd = 0,
                            allowSubscriptions = false,
                            allowFreeTrial = false,
                            excludeComboVariant = false,
                            hasFreeTrialItem = false,
                            minimumCart = -1;

                        if (typeof options !== 'undefined') {
                            if (typeof options.limit !== 'undefined') {
                                limit = options.limit;
                            }
                            if (typeof options.allowSubscriptions !== 'undefined') {
                                allowSubscriptions = options.allowSubscriptions;
                            }
                            if (typeof options.allowFreeTrial !== 'undefined') {
                                allowFreeTrial = options.allowFreeTrial;
                            }
                            if (typeof options.boQuantity !== 'undefined') {
                                boQuantity = options.boQuantity;
                            }
                            if (typeof options.goQuantity !== 'undefined') {
                                goQuantity = options.goQuantity;
                            }
                            if (typeof options.minimumCart !== 'undefined') {
                                minimumCart = options.minimumCart;
                            }
                        }

                        if (allowSubscriptions === true || hasSubscription(response)) {
                            makeCallback();
                            return false;
                        }

                        if (allowFreeTrial !== true) {
                            hasFreeTrialItem = hasTrialItem(response);
                            if (hasFreeTrialItem) {
                                makeCallback();
                                return false;
                            }
                        }

                        if (response.total_price > minimumCart) {
                            if (bo === -1) {
                                boAdded = 1;
                            } else {
                                response.items.forEach(function(item) {
                                    if (typeof item.variant_id !== 'undefined' && item.variant_id === bo) {
                                        boAdded += item.quantity;
                                    }
                                }, this);
                            }
                        }

                        if (boAdded > 0) {
                            response.items.forEach(function(item) {
                                if (typeof item.variant_id !== 'undefined' && item.variant_id === go.id) {
                                    // if (typeof item.variant_id !== 'undefined' && item.variant_id === go.id){ // && ((typeof item.properties == 'undefined') || (typeof item.properties !== 'undefined' && JSON.stringify(item.properties) === JSON.stringify(go.properties)))) {
                                        goAdded += item.quantity;
                                    // }
                                }
                            }, this);
                        }

                        toAdd = Math.max((Math.floor(boAdded / boQuantity) * goQuantity) - goAdded,0);

                        if (limit > 0){
                          //modify toAdd
                        }

                        if (toAdd > 0) {
                          go.quantity = toAdd;
                          addItem(go);
                        } else {
                          makeCallback();
                        }

                    });
                },
                init = function() {
                  promo = [{ //Theme Editor BOGO
                    action: function(obj) {
                      var init = function(c) {
                        console.log('promo called', c);
                        $.cookie.json = true;
                        var removeFromC = function(o,m){
                          var t = c;


                          o.forEach(function(i,j){
                            var removeTotal = i.quantity * m;

                            t.items.forEach(function(j,k){
                              if (i.id == j.id){
                                // Should check for discount property here
                                if (t.items[k].quantity <= removeTotal){
                                  removeTotal = removeTotal - t.items[k].quantity;
                                  t.items[k].quantity = 0;
                                } else {
                                  t.items[k].quantity = j.quantity - removeTotal;
                                  removeTotal = 0
                                }
                              }
                            });
                          });

                          return t;

                        },
                        runPro = function(p,o) {

                          if (typeof o === 'undefined'){
                            o = 0;
                          }

                          var handleAction = function(d){
                            var bo = d.bo,
                              go = d.go,
                              goAdd = [],
                              // obj = {id: go.id},
                              getBOMultiplier = function(bo){
                                var retArray = [];
                                  // boAdded = getVariantCount(bo,c);

                                if (bo.length == 0){
                                  retArray = [1];
                                }
                                bo.forEach(function(i,j,k){
                                  var excludeGo = false;
                                  if (typeof i.title !== 'undefined' && !!i.title){
                                    excludeGo = go;
                                  }
                                  retArray.push(Math.floor(getVariantCount(i,c,excludeGo) / i.quantity));
                                });

                                return Math.min.apply(null, retArray);

                              },
                              boMultiplier = getBOMultiplier(bo),
                              goAdded = false;//,
                              // boAdded = getVariantCount(bo,c),
                              // goAdded = getVariantCount(go,c),
                              // toAdd = Math.max((Math.floor(boAdded / bo.quantity) * go.quantity) - goAdded,0);

                            // if (toAdd > 0){

                              if (c.total_price >= p.cartThreshold && (boMultiplier > 0)){
                                go.forEach(function(i){
                                  var toAdd = (i.quantity * boMultiplier) -  getVariantCount(i,c),
                                    obj = {id: i.id};

                                  if (toAdd > 0){
                                    obj.quantity = toAdd;
                                    if (typeof i.discountProperty !== 'undefined'){
                                      obj.properties = {};
                                      obj.properties.Discount = i.discountProperty;
                                    }

                                    window.Shopify.queue.push({ action: 'add', data: obj });
                                    console.log('added!!!');
                                  }
                                });

                                c = removeFromC(bo,boMultiplier);

                              }
                            // }
                          };

                          if (p.go.length > 0 && typeof p.cartThreshold !== 'undefined'){
                            handleAction(p);
                          }
                          // if (typeof p.modal !== 'undefined'){
                          //   window.PromoModal = p.modal;
                          // }
                        },
                        privyCampaign = false,
                        promoData = window.Theme.promoData,
                        totalOffset = 0,
                        promoCookie = $.cookie('promoData'),
                        promoCode = !!sessionStorage.getItem("discount") ? sessionStorage.getItem("discount").toLowerCase() : '',
                        allowPromoCodeCombine = function(allowCodeMatch,requiredCode){
                          var ret = false;

                          if (!!requiredCode){
                            allowCodeMatch.push(requiredCode);
                          }

                          allowCodeMatch.forEach(function(i){
                            i = i.toLowerCase();
                            if (i.indexOf("*") > -1 && i == promoCode){
                              ret = true;
                            } else {
                              i = i.replace("*","");
                              if (promoCode.startsWith(i)){
                                ret = true;
                              };
                            }
                          });
                          return ret;
                        };

                        if (promoData.length > 0){
                          var tPromo = [];

                          promoData.forEach(function(i){
                            if (!i.requireCookieMatch || (!!i.requireCookieMatch && i.requireCookieMatch == promoCookie)){
                              tPromo.push(i);
                            }
                          });

                          promoData = window.Theme.promoData = tPromo;
                        }

                        tPromo = [];
                        if (promoData.length > 0){

                          promoData.forEach(function(i){
                            if (
                              !!i.enableBogo &&
                              (!i.requireCodeMatch || (!!i.requireCodeMatch && i.requireCodeMatch == promoCode)) &&
                              (!promoCode || allowPromoCodeCombine(i.allowCodeMatch,i.requireCodeMatch))
                            ){

                              // if (!promoCode){
                                tPromo.push(i);
                              // } else {
                              //
                              // }
                            }
                          });

                          promoData = window.Theme.promoData = tPromo;

                          tPromo = [];

                          promoData.forEach(function(i){
                            var loadThis = true;
                            if (i.discountPropertyExclude.length > 0){
                              i.discountPropertyExclude.forEach(function(j){
                                c.items.forEach(function(k){
                                  if (typeof k.properties.Discount !== 'undefined' && k.properties.Discount == j){
                                    loadThis = false;
                                  }
                                });
                              });
                            }
                            if (loadThis){
                              tPromo.push(i);
                            }
                          });
                        }

                        if (tPromo.length > 0){
                          //look for conflicts
                          tPromo.forEach(function(i,j){
                            if (i.go.length > 0){
                              i.go.forEach(function(k,l){
                                totalOffset +=  (k.offset * k.quantity);
                              });
                            }
                          });
                          tPromo.forEach(function(i,j){
                            runPro(i,totalOffset);
                          });
                        }

                        c.items.forEach(function(i){
                          if (typeof i.properties.Discount !== 'undefined' && i.properties.Discount.indexOf('Auto-Remove') >= 0){
                            if (i.total_discount == 0){
                              window.Shopify.queue.push({action:'change',data:{
                                id: i.key,
                                quantity: 0
                              }});
                            }
                          }
                        });

                        if (window.Shopify.queue.length > 0) {
                          window.Shopify.moveAlong(function(){
                            if (Theme.template.contains("cart")) {
                              window.location.reload(false);
                            } else {
                              Theme.minicart.update(true);
                            }
                          });
                        }

                        makeCallback();
                      };
                      getCart(init);
                    }


                  }];
                  setPromo(promo);
                  // Theme.minicart.update(true);
                }
            init();
        };
        // tempDiscounts();
        tempDiscounts(function(){
        //   Theme.minicart.update(false);
        },true);

        ratingClick = function() {
            var init = function() {
                    $elem.on('click', showRatings);
                },
                showRatings = function(e) {
                    $(window).scrollTo($(".tabbed-content"), 500, { offset: ($(".header-wrapper").height() + 20) * -1 });
                    $('.tabbed-content [href="#tab-ratings-reviews"]').click();
                    e.preventDefault();
                },
                $elem = $('.product-info [href="#tab-ratings-reviews"]');

            if ($elem.length > 0) {
                init();
            }
        }
        ratingClick();

        whenAvailable = function(name, callback, interval) {
            if (typeof interval == 'undefined'){
              interval = 10; // ms
            }
            window.setTimeout(function() {
                if (window[name]) {
                    callback(window[name]);
                } else {
                    window.setTimeout(arguments.callee, interval);
                }
            }, interval);
        };

        inventoryCheck = function(){
          if (window.Theme.template.indexOf('product') > -1 && window.Theme.inventoryTrigger.length > 0){
            var trigger = false,
            showPrivy = function(){
              Privy('show',trigger.privy_campaign);
            };

            window.Theme.inventoryTrigger.forEach(function(i){
              if (typeof i.privy_campaign !== 'undefined' && !window.Theme.product.available){
                trigger = i;
              }
            });

            if (!!trigger){
              setTimeout(function(){
                whenAvailable('Privy',showPrivy,1000);
              },500);
            }

          }
        };
        inventoryCheck();

        clickTracker = function() {
            var onClick = function(e) {
                    var $elem = $(e.currentTarget),
                        data = $elem.data('clicktrack'),
                        category = data.category,
                        label = data.label,
                        action = typeof data.action !== undefined ? data.action : 'click';

                        console.log(data);

                    // Use GTM dataLayer instead of deprecated Universal Analytics
                    if (typeof window.dataLayer !== 'undefined') {
                        window.dataLayer.push({
                            'event': 'custom_event',
                            'eventCategory': category,
                            'eventAction': action,
                            'eventLabel': label
                        });
                    }
                },
                init = function() {
                    $('body').on('click','[data-clicktrack]', onClick);
                };

            init();
        };
        clickTracker();

        review_hash = function() {
            var makeFormActive = function(){
              $([document.documentElement, document.body]).animate({
                  scrollTop: $('.spr-form').offset().top - 100
              }, 200);
              $('.spr-form').find('.spr-form-input').eq(0).focus();
            },
            callToggle = function(){
              if ($('.spr-form').is(':hidden')){
                try {
                  console.log('callToggle try');
                  console.log('');
                  var f = SPR.toggleForm(Theme.product.id);
                  console.log(f);
                } catch (e) {
                  console.log('callToggle catch');

                  setTimeout(callToggle,400);
                }
              }
            },
            showForm = function(){
                if (typeof SPR !== 'undefined' && $('.spr-form').length > 0){
                  callToggle();
                  makeFormActive();
                } else {
                  setTimeout(showForm,400);
                }
            },
            parseHash = function(hash, toCart) {
                var action = hash.replace("#", ''); //Puts hash in variable, and removes the # character
                if (action == "write_review"){
                  SPRCallbacks = {
                    onReviewsLoad: function( e ) {
                      showForm();
                    }
                  }
                }
            };

            if (window.location.hash) {
                parseHash(window.location.hash);
            }

        };
        review_hash();

        add_to_cart_hash = function() {
            var init = function(action, toCart) {
                    if (action[0] === "add") {
                        var items = action[1].split(',');

                        items.forEach(function(item) {
                            var quantity = 1,
                                id = item,
                                addData = {};

                            if (item.indexOf('x') > -1) {
                                id = item.split("x")[0];
                                quantity = item.split("x")[1];
                            }

                            addData.id = id;
                            addData.quantity = quantity;
                            if (action.length == 3) {
                                addData.properties = {
                                    Discount: decodeURIComponent(action[2])
                                };
                            }

                            window.Shopify.queue.push({ action: 'add', data: addData });

                        });
                        if (toCart === true) {
                            window.Shopify.moveAlong(function() {
                                window.location = '/cart';
                            });
                        } else {
                            window.Shopify.moveAlong(function(){
                                Theme.minicart.update(true);

                            });
                        }
                    }
                },
                removeHash = function() {
                    var scrollV, scrollH, loc = window.location;
                    if ("pushState" in history)
                        history.pushState("", document.title, loc.pathname + loc.search);
                    else {
                        // Prevent scrolling by storing the page's current scroll offset
                        scrollV = document.body.scrollTop;
                        scrollH = document.body.scrollLeft;

                        loc.hash = "";

                        // Restore the scroll offset, should be flicker free
                        document.body.scrollTop = scrollV;
                        document.body.scrollLeft = scrollH;
                    }
                },
                addItem = function(item, toCart) {
                    $.getJSON('/cart', function(response) {
                        itemAdded = false;

                        response.items.forEach(function(responseItem) {
                            if (typeof responseItem.variant_id !== 'undefined' && responseItem.variant_id === parseInt(item.id)) {
                                itemAdded = true;
                            }
                        }, this);
                        if (!itemAdded) {
                            $.ajax({
                                type: "POST",
                                url: '/cart/add.js',
                                data: item,
                                dataType: 'json',
                                success: function(data){
                                    Theme.minicart.update(true);
                                    removeHash();
                                },
                                error: function(xhr, status, error) {
                                    console.log(status);
                                    console.log(error);
                                }
                            });
                        } else {
                            Theme.minicart.update(true);
                        }

                    });
                },
                parseHash = function(hash, toCart) {
                    var action = hash.replace("#", '').split("__"); //Puts hash in variable, and removes the # character
                    init(action, toCart);
                },
                parseClick = function(e) {
                    var toCart = false,
                        $elem = $(this),
                        href = this.getAttribute('href');
                    if ($elem.data('hash-link') == 'cart') {
                        toCart = true;
                    }
                    parseHash(href, toCart);
                    e.preventDefault();
                };

            if (window.location.hash) {
                parseHash(window.location.hash);
            }

            $(document).on('click', '.hash-link', parseClick);

        };
        add_to_cart_hash();

        blogShare = function() {
            var countFormatter = function(num) {
                    if (num >= 1000000) {
                        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
                    }
                    if (num >= 1000) {
                        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
                    }
                    return num;
                },
                updateCounts = function($elem, data) {
                    var viewCount = countFormatter(data.items[0].statistics.viewCount),
                        likeCount = countFormatter(data.items[0].statistics.likeCount),
                        $viewElem = $elem.find('.video-share-count'),
                        $likesElem = $elem.find('.video-likes-count');

                    $viewElem.text(viewCount + " views");
                    $likesElem.text(likeCount);
                },
                getVideoData = function($elem, callback) {
                    var videoId = $elem.data('video-id');

                    $.ajax({
                        type: 'GET',
                        url: 'https://www.googleapis.com/youtube/v3/videos?part=statistics&id=' + videoId + '&key=AIzaSyDcYAY62b5Q-ZjTNM4YBxhX3DcKN8Z3eTo',
                        dataType: 'json',
                        success: function(data) {
                            callback($elem, data);
                        }
                    });
                },
                init = function() {
                    $videoStats = $('.video-stats');

                    if ($videoStats.length > 0) {
                        $videoStats.each(function(i, elem) {
                            var $elem = $(elem);
                            getVideoData($elem, updateCounts);
                        });
                    }
                };
            init();
        }
        blogShare();

        showHide = function() {
            var actionClick = function(e) {
                    var $elem = $(e.currentTarget),
                        $target = $($elem.data('target'));

                    $target.toggleClass('hide');
                },
                init = function() {
                    $('.showHide').on('click', actionClick);
                };
            init();
        }
        showHide();

        updateQtyInMiniCart = function(){
            var qtyInput = '#cart-app input[name="updates-vue[]"]';
            
            function qtyChange() {
                var elem = this,
                    $elem = $(elem),
                    qty = $elem.val(),
                    key = $elem.data('line-key');
                
                jQuery.post('/cart/change.js', { 
                    id: key,
                    quantity: qty 
                });

                setTimeout(() => window.miniCart.refreshCart(), 1000);
            }
  
            $(document).on('change', qtyInput, qtyChange);
        };
        updateQtyInMiniCart();

        removeItemInMiniCart = function(){
            var removeEle = '.remove-mini-cart-item-vue';
            
            function qtyChange() {
                var elem = this,
                    $elem = $(elem),
                    qty = 0,
                    key = $elem.data('key');
                
                jQuery.post('/cart/change.js', { 
                    id: key,
                    quantity: qty 
                });

                setTimeout(() => window.miniCart.refreshCart(), 1500);
                console.log('Item removed.');
            }
  
            $(document).on('click', removeEle, qtyChange);
        };
        removeItemInMiniCart();

    });

}).call(this);



$(document).ready(function() {

    var scrollOnPage = function($target,time,stopAt) {
    // Clear whatever is at top of page, usually the header
        // var clearThis = $('.header-wrapper').height() + 25;
        var clearThis = $('.header-wrapper').height();
        var tarHght  = $($target).height();
        pos = 0;
        if ( stopAt == '' ) {
            pos =  ( window.innerHeight / 10 );
        }
        if ( stopAt == 'top' ) {
            pos =  0;
        }
        if ( stopAt == 'center' ) {
            pos =  ( window.innerHeight / 2 ) - ( tarHght );
        }
        if ( stopAt == 'bottom' ) {
            pos =  ( window.innerHeight );
        }
        $('html, body').animate({
            scrollTop: $target.offset().top - clearThis - pos
        }, time, function() {
            var x = window.scrollX,
                y = window.scrollY;
            // Callback after animation
            // Must change focus!
            $target.focus();
            window.scrollTo(x, y);
            if ($target.is(":focus")) { // Checking if the target was focused
                return false;
            } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
                window.scrollTo(x, y);
            };
        });
    },
    init = function() {
        var hash = window.location.hash;
        if ( !hash.contains('?') ) {
            var $hash = $(hash);
            if ($hash.length > 0) {
                $(window).load(function() {
                    scrollOnPage($hash, 0);
                });
            }
        }
    };
    init();

    $('a[href]')
        .not('.img-tab-link-2') // .not() ignores anchors with this class
        .not('[href*="tel:"]')
        .not('.flexslider a')
        .not('[href*="mailto:"]')
        .not('.subscription-tooltip')
        .each(function() {

        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });

    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.no-scroll')
        .click(function(event) {
            timing = 750;
            stopAt = '';
            if ( $(this).is('.slow-scroll') ) {timing = timing * 2;}
            if ( $(this).is('.fast-scroll') ) {timing = timing / 2;}
            if ( $(this).is('.mid-window') ) {stopAt = 'center';}
            if ( $(this).is('.top-window') ) {stopAt = 'top';}
            if ( $(this).is('.bot-window') ) {stopAt = 'bottom';}
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var $target = $(this.hash);
                $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if ($target.length) {
                    // Only prevent default if animation is actually gonna happen
                    scrollOnPage($target,timing,stopAt);
                    event.preventDefault();
                }
            }
        });
})



/*!
  FitText.js 1.2

  Copyright 2011, Dave Rupert http://daverupert.com
  Released under the WTFPL license
  http://sam.zoy.org/wtfpl/

  Date: Thu May 05 14:23:00 2011 -0600
*/

$(document).ready(function($) {

    $.fn.fitText = function(kompressor, options) {

        // Setup options
        var compressor = kompressor || 1,
            settings = $.extend({
                'minFontSize': Number.NEGATIVE_INFINITY,
                'maxFontSize': Number.POSITIVE_INFINITY
            }, options);

        return this.each(function() {

            // Store the object
            var $this = $(this);

            // Resizer() resizes items based on the object width divided by the compressor * 10
            var resizer = function() {
                $this.css('font-size', Math.max(Math.min($this.width() / (compressor * 10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
            };

            // Call once to set.
            resizer();

            // Call on resize. Opera debounces their resize by default.
            $(window).on('resize.fittext orientationchange.fittext', resizer);

        });

    };

});


function matchHeight(container) {
    function init() {
        eventListeners();
        matchHeight();
    }

    function eventListeners() {

        $(window).on('resize', function() {
            matchHeight();
        });
    }

    function matchHeight() {
        var groupName = $(container);
        var groupHeights = [];
        groupName.css('min-height', 'auto');
        groupName.each(function() {
            groupHeights.push($(this).outerHeight());
        });
        var maxHeight = Math.max.apply(null, groupHeights);
        groupName.css('min-height', maxHeight);
    };
    init();
}

equalheight = function(container){
    initEqual();
    $(window).resize(function(){
        initEqual();
    });
    function initEqual() {
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;
        $(container).each(function() {
            $el = $(this);
            $($el).height('auto')
            topPostion = $el.position().top;
            if (currentRowStart != topPostion) {
                for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPostion;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            }
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
        });
    }
}

$(document).ready(function() {
    // Product Accordian
    var animTime = 300,
        clickPolice = false;

    $(document).on('click touch', '.acc-btn:not(.make-link)', function() {
        if (!clickPolice) {
            clickPolice = true;
            var currIndex = $(this).index('.acc-btn'),
                targetHeight = $('.acc-content-inner').eq(currIndex).outerHeight();
            var expanded = $(this).find('h3').hasClass('selected');
            if (expanded) {
                $('.acc-btn h3').removeClass('selected');
                $('.acc-btn .img').removeClass('selected');
                $('.acc-content').eq(currIndex).stop().animate({ height: targetHeight }, animTime);
                $('.acc-content').stop().animate({ height: 0 }, animTime);
            } else {
                winWidth = $(window).width();
                openTab = $('.acc-btn h3.selected');
                console.log(openTab.length)
                if (openTab.length > 0 && winWidth < 767) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: openTab.offset().top - 60
                    }, animTime);
                }
                $('.acc-btn h3').removeClass('selected');
                $('.acc-btn .img').removeClass('selected');
                $(this).find('h3').addClass('selected');
                $(this).find('.img').addClass('selected');
                $('.acc-content').stop().animate({ height: 0 }, animTime);
                $('.acc-content').eq(currIndex).stop().animate({ height: targetHeight }, animTime);
            }
            setTimeout(function() { clickPolice = false; }, animTime);
        }
    });



    function loadMoreReviews(el) {
        chkDelay = '200'; // Amount of time between Checks
        var chkExist = setInterval(function() {
            chkClass = $(el);
            if (chkClass.length) {
                clearInterval(chkExist);

                total = chkClass.length;
                moreButton = '<div class="text-center"><a href="#" class="load-more">Load More</a></div>';
                // console.log(total)

                if (total > 3) {
                    chkClass
                        .parent().children(':nth-of-type(n + 4)')
                        .hide();
                    chkClass.last()
                        .after(moreButton);

                    $('.load-more').on('click touch', function(e) {
                        e.preventDefault();
                        $(this).parent().parent().children().show();
                        $(this).hide();
                    })
                }

            }
        }, chkDelay);
    }
    rev_watch = '.product .spr-review';
    loadMoreReviews(rev_watch)

    // Scrolls and opens reviews when you click on stars
    reviews_href = '#tab-ratings-reviews';
    if (window.location.href.indexOf(reviews_href) > -1) {

        thisHash = window.location.hash;


        (function(window, location) {
            history.replaceState(null, document.title, location.pathname+reviews_href);
            history.pushState(null, document.title, location.pathname);

            window.addEventListener("popstate", function() {
              if(location.hash === reviews_href) {
                    // history.replaceState(null, document.title, location.pathname);
                    setTimeout(function(){
                      // location.replace(window.history.back(-3));
                      console.log(history)
                      console.log(history.state)
                      console.log(window.history)
                      console.log(window.history.state)
                    },0);
              }
            }, false);
        }(window, location));


        // for product pages
        tab_trig = $('[href=' + reviews_href + ']');
        if (thisHash && tab_trig.length) {
            tab_trig.trigger('click');
            history.pushState(thisHash, '', window.location.pathname);
            setTimeout(function() {
                clearThis = $('#masthead').height() + 25;
                $('html, body').animate({
                    scrollTop: $(thisHash).offset().top - clearThis
                }, 1000);
            }, 200)
        }

        // For Landing Pages
        // var revCookie = Cookies.get("openReviews");
        if (thisHash && !!$.cookie('openReviews') && $.cookie('openReviews') != null) {
            // history.pushState(thisHash, '', window.location.pathname);

            chkDelay = '200'; // Amount of time between Checks
            count = 0;

            // Check for reviews section content and duplicate if necissary
            var chkExist = setInterval(function() {
                chkClass = $('#' + $.cookie('openReviews'));
                if (chkClass.length) {
                    $.removeCookie("openReviews");
                    $.removeCookie("openReviews", { path: '/' });
                    $.removeCookie("openReviews", { path: '/collections/' });
                    $.removeCookie("openReviews", { path: '/collections' });
                    openID = chkClass.first().closest('.badge_open').attr('data-open');
                    $('#' + openID).addClass('active');
                    clearInterval(chkExist);
                    count = 0;
                }
            }, chkDelay);
        }
    }

    function reOrder(par, chld) {
        par = $(par);
        chld = chld;
        min = 990;
        items = par.find(chld);
        below = 'below';
        above = 'above';
        status = '';
        num = 1; // actually the second in array
        moved = false;

        var arr = [];
        items.each(function(i) {
            $(this).attr('data-index', i);
            arr.push($(this));
        })


        initReorder();
        $(window).resize(function() {
            initReorder();
            // console.log("$(window).width()", $(window).width());
        })

        function initReorder() {
            below_width = $(window).width() < min;
            above_width = $(window).width() >= min;

            if (below_width && moved == false) {
                // console.log("moved",moved);
                // mobile adjustments
                num = 1;
                par.find(chld).each(function(i) {
                    item = $(this);
                    set_index = parseInt(item.attr('data-index'));
                    // Move on Mobile
                    if (set_index == num) {
                        num = num + 2;
                        if (item.hasClass('wide')) {
                            status = below;
                            new_index = set_index + 1;
                            // console.log(new_index)
                            item.insertAfter('[data-index="' + new_index + '"]');
                            moved = true;
                        }
                    }
                })
            } else if (above_width && moved == true) {
                // desktop adjustments
                $original_html = $("<div></div>");
                par.find(chld).each(function(i) {
                    // Move back on Desktop
                    $original_html.append(arr[i])
                });
                if (moved) {
                    par.html($original_html.html())
                    moved = false;
                }

            }


        }
    }

    reOrder('[order-check-2]', '.product-small')


    StopYO = '.badge_open';

    jQuery(document).on('touch click', StopYO, function(e) {
        e.preventDefault();
        openID = $(this).data('open');
        $('[id="' + openID + '"]').addClass('active');
    })



    function marqueText(par, chld) {
        // par = par || '.product-small .length-check.too-long,.product-small .length-check.way-too-long';
        par = par || '.product-small .length-check';
        chld = chld || 'span';

        initMarq()
        $(window).resize(function() {
            initMarq()
        })

        function initMarq() {
            $(par).each(function() {
                parWdth = $(this).outerWidth();
                chldWdth = $(this).children(chld).outerWidth();
                txt = $(this).children(chld).text();
                // console.log(txt,chldWdth,parWdth)
                if ( chldWdth > parWdth ) {
                    if ( !$(this).is('too-thin') ) {
                        $(this).addClass('too-thin')
                    }
                    $(this).children(chld).attr('style', '--sub-length: ' + chldWdth + 'px; --par-length: ' + parWdth + 'px;')
                } else {
                    $(this).removeClass('too-thin')
                }
            })
        }
    }
    // marqueText();
});

function setFixed(el) {
    var thisJsEl    = $(el)[0],
        thisJqEl    = $(el),
        status      = 'Page Load',
        fixed       = 'fixed',
        rel         = 'relative',
        stop        = 'stop',
        prevStatus  = '';

    initFixed()
    $(window).scroll(function() {
        initFixed()
    })
    $(window).resize(function() {
        initFixed(true)
    })

    function initFixed(rsz) {
        // Set Child on first loop
        if ( prevStatus == '' ) {
            thisJqEl.wrapInner('<div></div>');
        }
        // Settings
        var body            = document.body,
            html            = document.documentElement,
            fullPageHght    = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight ),
            scrollTop       = document.body.scrollTop,
            pageWidth       = window.innerWidth,
            clearThis       = $('.header-wrapper')[0].offsetHeight + 15,
        // Elements
            fxdJsChld       = thisJqEl.children('div')[0],
            fxdJqChld       = thisJqEl.children('div'),
            par             = thisJqEl.parent(),
        // Sizing
            parRectTop      = par[0].getBoundingClientRect().top,
            startPoint      = parRectTop - clearThis,
            parBottom       = par[0].offsetHeight - fxdJsChld.offsetHeight,
            stopPoint       = startPoint + parBottom,
            elWidth         = fxdJsChld.offsetWidth,
            elPadding       = parseInt(thisJqEl.css('padding-left')),
            parLeft         = par.offset().left,
            elLeft          = parLeft + elPadding,
        // Trigger Points
            stopHere        = scrollTop >= stopPoint,
            startFixed      = startPoint <= scrollTop && !stopHere,
            startRel        = startPoint > scrollTop,
            minWidth        = pageWidth >= 750,
        // Breakpoints Logic
            isFixed         = startFixed && status != fixed && minWidth,
            isRelative      = ( startRel  && status != rel ) || !minWidth,
            isStopped       = stopHere  && status != stop && minWidth,
            isResize        = rsz && minWidth,
            isFirstLoop     = !par.get(0).hasAttribute('style');


        if ( isFirstLoop ) {
            par.css('position',rel);
        }
        if ( isFixed ) {
            status = fixed;
            fxdJqChld
                .attr('style','')
                .css('position', 'fixed')
                .css('top',clearThis)
                .css('left',elLeft)
                .css('width',elWidth)
                .css('z-index','1')
        }
        if ( isRelative ) {
            status = rel;
            fxdJqChld
                .attr('style','');
        }
        if ( isStopped ) {
            status = stop;
            fxdJqChld
                .attr('style','')
                .css('position', 'absolute')
                .css('bottom', '0')
                .css('left',elPadding)
                .css('width',elWidth)
                .css('z-index','1')
        }
        if ( isResize ) {
            if ( status != fixed ) {
                elLeft = 0;
            }
            fxdJqChld
                .css('left',elLeft)
                .css('width',elWidth)
        }
        currStatus = prevStatus != status;
        if (currStatus) {
            // console.log(status)
        }
        prevStatus = status;
    }
}








// Ongoing ADA Setup

$(document).ready(function() {
    // keyup codes
    tab = 9,
    enter = 13,
    esc = 27,
    up = 38,
    left = 37,
    right = 39,
    down = 40;


    // $('body').append('<div class="tab-checker"><div><label>Type</label><span id="type"></span></div><div><label>Element</label><span id="el"></span></div></div>')

    lastCount=0;
    firstCount=0;
    focusOutCount=0;
    iframeLoaded = false;
    $(window).keyup(function(e) {

        code = (e.keyCode ? e.keyCode : e.which);

        thisFocus       = $(':focus');

        focusExists     = $(':focus').length;

        isTab           = code == tab;
        isNextTab       = code == tab && !e.shiftKey;
        isPrevTab       = code == tab && e.shiftKey;

        isEnter         = code == enter;
        isLeft          = code == left;
        isRight         = code == right;
        isEsc           = code == esc;


        if ( isTab && focusExists ) {
            var text = thisFocus.text();
                shortText   = jQuery.trim(text).substring(0, 150).replace(/(\r\n|\n|\r)/gm, "").replace(/(^\s+|\s+|\s+$)/gm, " ").trim();
                ths         = thisFocus[0];
                type        = ths.nodeName.toLowerCase();
                clss        = ths.className.split(' ')[0];
                thsClss     = '';
                if (clss != '') { thsClss = '.' + clss; }
            console.log(type + thsClss + ' / "' + shortText +'"')
            console.log(thisFocus)
        }


        if ( isEnter && thisFocus.is('.acc-btn') ) {
            $('.acc-btn:focus').click();
        }

        if ( $('#video_modal').is('.active') ) {
            // $('.acc-btn:focus').click();
            curData = 'video_modal';
            container = $('[id="' + curData + '"]');
            reset = $('[data-open="' + curData + '"]');
            close = $('[data-close="' + curData + '"]');
            lastItem = container.find(':focusable').last();
            firstItem = container.find(':focusable').first();


            // Close if X is Entered
            if ( thisFocus.is('.close-modal') && isEnter ) {
                closeModal();
            }
            // Close on Escape
            if ( isEsc ) {
                closeModal();
            }
            // Reset Counters
            if ( isPrevTab ) {
                lastCount=0;
            }
            if ( isNextTab ) {
                firstCount=0;
            }
            // Wait to Close Modal
            if ( thisFocus.is(firstItem) && isPrevTab ) {
                firstCount++;
                if ( firstCount == 1 ) {
                    return false;
                }
            }
            // Close Modal if Back Tab from First :focus
            if ( firstCount == 1 && isPrevTab && !thisFocus.is(firstItem) ) {
                firstCount=0;
                closeModal();
                return false;
            }
            // Wait to Close Modal
            if ( thisFocus.is(lastItem) && isNextTab ) {
                lastCount++;
                if ( lastCount == 1 ) {
                    return false;
                }
            }
            // Close Modal if Next Tab from Last :focus
            if ( lastCount == 1 && isNextTab && !thisFocus.is(lastItem) ) {
                lastCount=0;
                closeModal();
                return false;
            }


            container.on('focusout', function () {
                var $elem = $(this);
                // let the browser set focus on the newly clicked elem before check
                checker = setTimeout(function () {
                    if (!$elem.find(':focus').length) {
                        closeModal();
                    }
                }, 0);
            });


            function closeModal() {
                close.click();
                reset.focus();
                lastCount=0;
                container.attr('tabindex',-1);
                clearTimeout(checker)
            }

        }

        if ( isEnter && thisFocus.is('.scent-selector') ) {
            $('.scent-selector:focus').click();
        }
        // Shoe~Pourri Page
        if ( isEnter && thisFocus.is('.badge_open') ) {
            thisFocus.click();
            curBarCode = thisFocus.data('open');
            container = $('[id="' + curBarCode + '"]');
            container.attr('tabindex',0);
            firstItem = container.find(':focusable').first();
            firstItem.focus();
        }
        if ( $('.reviews-modal').is('.active') ) {
            curBarCode = $('.reviews-modal.active').attr('id');
            container = $('[id="' + curBarCode + '"]');
            reset = $('[data-open="' + curBarCode + '"]');
            close = $('[data-close="' + curBarCode + '"]');
            firstItem = container.find(':focusable').first();
            lastItem = container.find(':focusable').last();

            // console.log('First Item: ',firstItem)
            // console.log(firstItem)

            // Close if X is Entered
            if ( thisFocus.is('.close-modal') && isEnter ) {
                closeModal();
            }
            // Close on Escape
            if ( isEsc ) {
                closeModal();
            }
            // Reset Counters
            if ( isPrevTab ) {
                lastCount=0;
            }
            if ( isNextTab ) {
                firstCount=0;
            }
            // Wait to Close Modal
            if ( thisFocus.is(firstItem) && isPrevTab ) {
                firstCount++;
                if ( firstCount == 1 ) {
                    return false;
                }
            }
            // Close Modal if Back Tab from First :focus
            if ( firstCount == 1 && isPrevTab && !thisFocus.is(firstItem) ) {
                firstCount=0;
                closeModal();
                return false;
            }
            // Wait to Close Modal
            if ( thisFocus.is(lastItem) && isNextTab ) {
                lastCount++;
                if ( lastCount == 1 ) {
                    return false;
                }
            }
            // Close Modal if Next Tab from Last :focus
            if ( lastCount == 1 && isNextTab && !thisFocus.is(lastItem) ) {
                lastCount=0;
                closeModal();
                return false;
            }
            container.on('focusout', function () {
                var $elem = $(this);
                // let the browser set focus on the newly clicked elem before check
                checker = setTimeout(function () {
                    if (!$elem.find(':focus').length) {
                        closeModal();
                    }
                }, 0);
            });
            function closeModal() {
                close.click();
                reset.focus();
                lastCount=0;
                container.attr('tabindex',-1);
                clearTimeout(checker)
            }
        }


        if ( isEnter && thisFocus.is('.open-modal[data-open]') ) {
            thisFocus.click();
            curBarCode = thisFocus.data('open');
            container = $('[id="' + curBarCode + '"]');
            container.attr('tabindex',0);
            firstItem = container.find(':focusable').first();
            firstItem.focus();
            focusItems = container.find(':focusable').length;
        }

        if ( $('.modal').is('.active') ) {

            curActive = $('.modal.active');
            curData = curActive.attr('id');
            container = $('[id="' + curData + '"]');
            reset = $('[data-open="' + curData + '"]');
            close = $('[data-close="' + curData + '"]');
            firstItem = container.find(':focusable').first();
            lastItem = '';
            // curActive.find('iframe').load(function () {
            //     $(this).focus();
            //     iframeLoaded=true;
            //     lastItem = $(this).find(':focusable').last();
            //     // console.log(lastItem)
            // })

            // if ( $(this).find(':focusable').last() != lastItem ) {
            //     lastItem = $(this).find(':focusable').last();
            // }

            // console.log(lastItem)

            // curActive.focusout(function () {
            //     focusOutCount++;
            //     // console.log('out');
            //     nextFocus='';
            //     if ( focusOutCount == 1 ) {
            //         nextFocus = thisFocus;
            //     }

            //     console.log(nextFocus, focusOutCount);
            // })

            // if ( thisFocus.is(nextFocus) ) {
            //     closeModal()
            // }
            // Close if X is Entered
            if ( thisFocus.is('[data-close]') && isEnter ) {
                closeModal();
            }
            // Close on Escape
            if ( isEsc ) {
                closeModal();
            }
            // Reset Counters
            if ( isPrevTab ) {
                lastCount=0;
            }
            if ( isNextTab ) {
                firstCount=0;
            }
            // Wait to Close Modal
            if ( thisFocus.is(firstItem) && isPrevTab ) {
                firstCount++;
                if ( firstCount == 1 ) {
                    return false;
                }
            }
            // Close Modal if Back Tab from First :focus
            if ( firstCount == 1 && isPrevTab && !thisFocus.is(firstItem) ) {
                firstCount=0;
                closeModal();
                return false;
            }

            // if ( thisFocus.not(reset) || thisFocus.not(close) && lastItem[0].className == '.iframe-video' && isNextTab ) {
            //     focusOutCount++;
            //     if ( focusOutCount == 1 ) {
            //         nextFocus = thisFocus;
            //     }
            // }
            // // Wait to Close Modal
            // if ( thisFocus.is(lastItem) && isNextTab ) {
            //     lastCount++;
            //     if ( lastCount == 1 ) {
            //         return false;
            //     }
            // }
            // // Close Modal if Next Tab from Last :focus
            // if ( lastCount == 1 && isNextTab && !thisFocus.is(lastItem) ) {
            //     lastCount=0;
            //     closeModal();
            //     return false;
            // }

            container.on('focusout', function () {
                var $elem = $(this);
                // let the browser set focus on the newly clicked elem before check
                checker = setTimeout(function () {
                    if (!$elem.find(':focus').length) {
                        closeModal();
                    }
                }, 0);
            });
            function closeModal() {
                close.click();
                reset.focus();
                lastCount=0;
                // container.attr('tabindex',-1);
                clearTimeout(checker)

            }

        }




        // lost_password
        // if (code == enter && $(':focus').is('.acc-btn')) {
        //     $('.acc-btn:focus').click();
        // }


    });


    $("#login-form .lost_password").click(function(e) {
        e.preventDefault();
        $('#retreive-password-email').focus();
    });

    $("#recover-form .lost_password").click(function(e) {
        e.preventDefault();
        $('#login-email').focus();
    });




    $mainContent = '#main-content';
    $mainNav = '#masthead';


    $(".to-main-content").click(function(e) {
        e.preventDefault();
        $($mainContent).focus();
    });

    $(".to-navigation").click(function(e) {
        e.preventDefault();
        $($mainNav).focus();
    });
    $(".to-top").click(function(e) {
        e.preventDefault();
        $('#top').focus();
        $(window).scrollTop(0);
    });

});




// Dont judge me, i know how 100% hacky this is but it seems to work. - Austin :)
function copyReviews(el) {
    chkDelay = '200'; // Amount of time between Checks
    count = 0;

    // Check for reviews section content and duplicate if necissary
    var chkExist = setInterval(function() {
        el = el;
        chkID = $(el).data('id');
        // chkClass    = $(el+'[data-id="'+chkID+'"]');
        chkClass = $('[data-id="' + chkID + '"]:not(.product-small)');

        if (chkClass.length >= 2 && (chkClass.find('.spr-reviews').children().length || chkClass.find('.spr-form').children().length)) {
            grabContent = chkClass.first().html();
            chkClass.html(grabContent);
            clearInterval(chkExist);
            count = 0;
            // console.log(chkClass)
        }


    }, chkDelay);

    // When duplicated item has review added, open the original to show success message
    var chkSuccess = setInterval(function() {
        el          = el;
        chkID       = $(el).data('id');
        chkClass    = $('[data-id="'+chkID+'"]:not(.product-small)');
        if ( chkClass.length > 1 && chkClass.find('.spr-form-message').length ) {
            first       = chkClass.first();
            successMess = chkClass.find('.spr-form-message').closest('.spr-content').html();
            replaceMess = chkClass.find('.spr-content');
            // Reset to first instance because that's where the success shows.
            if ( !first.closest('.reviews-modal').is('active') ) {
                $('.reviews-modal.active').removeClass('active');
                first.closest('.reviews-modal').addClass('active');
            }
            // Replace all other instances with the right content.
            replaceMess.html(successMess);
            clearInterval(chkSuccess);
        }
    }, chkDelay);
}

function change_info(el) {
    chkDelay = '200'; // Amount of time between Checks
    var chkExist = setInterval(function() {
        chkClass = $(el);
        if (chkClass.length) {
            clearInterval(chkExist);

            stars = '.spr-starrating.spr-summary-starrating';
            header = '.spr-header-title';

            setTimeout(function() {
                $(header).text('Ratings + Reviews');
                $(stars).insertBefore(header);
            }, 100)
        }
    }, chkDelay);
}
// rev_watch = '.product .spr-review-header-title';
// change_info(rev_watch)
function showData(el) {
    chkDelay = '200'; // Amount of time between Checks
    var chkExist = setInterval(function() {
        chkClass = $(el);
        if (chkClass.length) {
            clearInterval(chkExist);
            count = 0;
            chkClass.each(function() {
                ratData = $(this).data('rating');
                ratConv = parseFloat(ratData).toFixed(1);
                ratStars = $(this).children('.spr-badge-starrating');
                ratText = $(this).children('.spr-badge-caption');
                ratTotal = ratText.text().split(' ')[0];
                count++;
                if (ratTotal == 'No') { ratTotal = '0'; }
                if (ratConv != 0.0 && ratConv != 0) {
                    if (ratTotal == 1){
                      ratStars.after('<span class="rating-number">' + ratTotal + ' review</span>');
                    } else {
                      ratStars.after('<span class="rating-number">' + ratTotal + ' reviews</span>');
                    }
                }
                ratText.text('');

                // match height of info section.
                // here to make sure the height
                // is only changed after this function runs
                var item = $('.product-small:not(.wide):not(.no-mh) .quick-buy .flex-meta');
                matchHeight(item);
            })
        }
    }, chkDelay);
}
// rat_cont = '.collection-template .spr-badge, .collection-shoe-pourri .spr-badge';
// showData(rat_cont)

function leaveReview(el) {
    chkDelay = '200'; // Amount of time between Checks
    var chkExist = setInterval(function() {
        chkClass = $(el);
        if (chkClass.length) {
            clearInterval(chkExist);
            count = 0;
            chkClass.each(function() {

                ratText = $(this).children('.spr-badge-caption');
                ratTotal = ratText.text().split(' ')[0];
                count++;

                if (ratTotal == 'No') { ratTotal = '0'; }
                if (ratTotal <= 5){
                    // console.log(count,ratTotal)
                    $(this).addClass('be-first');
                    // ratText.wrapInner('<span class="hover-hide"></span>');
                    // ratStars.after('<span class="rating-number">' + ratTotal + ' review</span>');
                } else {
                  // ratStars.after('<span class="rating-number">' + ratTotal + ' reviews</span>');
                }

            })
        }
    }, chkDelay);
}
rat_cont = '.collection-template .spr-badge, .collection-shoe-pourri .spr-badge, .page-story-of-poo .spr-badge';
leaveReview(rat_cont)

function centerContentResizer( par, chld, hght, type ){
    container = par;
    content = chld;
    hght = hght;
    type = type;
    initCheck();
    $(window).resize(function() {
        initCheck();
    });
    function initCheck() {
        if (typeof hght === 'undefined') {hght = 120;}
        if (typeof type === 'undefined') {type = 'min-height';}
        $containerHeight = $(container).outerHeight();
        $contentHeight = $(content).outerHeight() + hght;
        if ( $containerHeight < $contentHeight ) {
            $(container).css(type, $contentHeight);
        }
    }
}



function videoRatio(arr) {
    var min_w   = 1000;
    var vid_w_orig;
    var vid_h_orig;
    // Defaults that can be overridden
    vid         = $(arr.vid) || $('iframe.full-width, video.full-width');
    mainPar     = arr.mainPar || '.background-image';
    xType       = arr.xType || 'left';
    yType       = arr.yType || 'top';
    xOffset     = arr.xOffset || '0%';
    yOffset     = arr.yOffset || '0%';
    // Init Function
    initRatio();
    // Init on Resize
    $(window).resize(function () {
        initRatio();
    })
    function initRatio() {
        if (vid.length) {
            vid.each(function () {
                // Window Measurements
                winHght         = $(window).height();
                winWdth         = $(window).width();


                // Video Measurements
                thsVid          = $(this);
                thsVidHght      = thsVid.height();
                thsVidWdth      = thsVid.width();
                // thsVidHght      = thsVid.width() * 2;
                // Video Parents Measurements
                thsVidPar       = thsVid.parent();
                parHght         = thsVid.closest(mainPar).height();
                parWdth         = thsVid.closest(mainPar).width();

                if ( !thsVid.attr('load-width') ) {
                    vid_w_orig      = parseInt(thsVid.attr('width'));
                    vid_h_orig      = parseInt(thsVid.attr('height'));
                    thsVid.attr('load-height',vid_h_orig).attr('load-width',vid_w_orig)
                }

                loadWdth        = thsVid.attr('load-width');
                loadHght        = thsVid.attr('load-height');

                // if ( winHght <= ( parHght + 150 ) ) {
                //     loadHght    = loadHght * 1.5;
                // }
                // use largest scale factor of horizontal/vertical
                scale_h         = winWdth / loadWdth;
                scale_v         = winHght / loadHght;
                scale           = scale_h > scale_v ? scale_h : scale_v;
                // don't allow scaled width < minimum video width
                if ( scale * loadWdth < min_w ) {
                    scale       = min_w / loadWdth;
                    // console.log(min_w)
                };
                // console.log(scale)
                // Final Measurements
                xPosPx          = (thsVidWdth - parWdth) / 2;
                yPosPx          = (thsVidHght - parHght) / 2;
                xPos            = 'calc('+xOffset+' - '+ xPosPx +'px )';
                yPos            = 'calc('+yOffset+' - '+ yPosPx +'px )';
                // set the video viewport to the window size
                thsVidPar.width(winWdth).height(winHght);
                // now scale the video
                thsVid.width(scale * loadWdth).height(scale * loadHght);
                // and center it by scrolling the video viewport
                thsVid.css( xType, xPos ).css( yType, yPos );
                // Hide If mobile or small screen
                if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || winWdth < 750 ) {
                    thsVid.hide();
                } else {
                    thsVid.show();
                }
            })
        }
    }
}



/*
    Video Display =>
*/
function videoDisplay(el) {
    thsVid  = $(el);
    status;
    initRatio();
    $(window).resize(function () {
        initRatio();
    })
    function initRatio() {
        winWdth = $(window).width();
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || winWdth < 750 && status != 'hide' ) {
            thsVid.addClass('hide');
            status = 'hide';
        }
        if ( winWdth >= 750 && status != 'show' ) {
            thsVid.removeClass('hide');
            status = 'show';
        }
    }
}


/*
    Modal Pop up =>
*/
function Modal(el,options) {
    var el = el,
        evt = el.event;
    // evt.preventDefault();
    initMdl(el)
    function initMdl(el) {
        var winWidth    = $(window).width(),
            thisEl      = el,
            getDta      = getDataName($(thisEl)),
            type        = getDta.length ? getDta : 'modal',
            thisMdl     = getDta.length ? $('[data-modal="'+ String($(thisEl).data(type)).trim() +'"]') : $(thisEl);

        // console.log(getDta)
        // console.log(type)
        // console.log(thisMdl)
        if ( type == 'open' || type == 'modal' ) {
            // console.log(!thisMdl.is('.active'))
            if ( !thisMdl.is('.active') ) {
                showModal(thisMdl);
            } else {
                hideModal(thisMdl);
            }
        }
        if ( type == 'close' ) {
            hideModal(thisMdl);
        }
    }
    function showModal (el) {
        el = $(el);
        el.addClass('active');
        el.find(':focusable').first().focus();
        if (typeof options !== 'undefined' && typeof options.onShow !== 'undefined'){
          options.onShow(el);
        }
    }
    function hideModal(el) {
        el = $(el);
        el.removeClass('active');
        if (typeof options !== 'undefined' && typeof options.onHide !== 'undefined'){
          options.onHide(el);
        }
    }
    function getDataName(node) {
        var d = {},
            key ='',
            re_dataAttr = /^data\-(.+)$/;
        $.each(node.get(0).attributes, function(index, attr) {
            if (re_dataAttr.test(attr.nodeName)) {
                key = attr.nodeName.match(re_dataAttr)[1];
            }
        });
        return key;
    }
}


function resizeEnd(rLog) {
    var rCycle = 500;
    var rLog = rLog || false;
    rTime = new Date();
    rStatus = '';
    if ( typeof rTimeout === 'undefined' || rTimeout === false ) {
        rTimeout = true;
        setTimeout(rInit, rCycle);
    }
    function rInit() {
        if (new Date() - rTime < rCycle) {
            setTimeout(rInit, rCycle);
            rStatus = false;
        } else {
            rTimeout = false;
            rStatus = true;
        }
        return rStatus;
    }
    if ( rLog == true ) {
        console.log('Status:  '+rStatus)
    }
    return rStatus;
}



$(document).ready(function() {

    // rat_cont = '.collection-template .spr-badge, .collection-shoe-pourri .spr-badge';
    // showData(rat_cont)

    rev_watch = '.product .spr-review-header-title';
    change_info(rev_watch)

    rat_cont = '.collection-shoe-pourri #shopify-product-reviews, .collection-privy #shopify-product-reviews';
    copyReviews(rat_cont)


    $('.spr-link-wrap').click(function(e) {
        prodID = $(this).find('.spr-badge').attr('id');
        $.cookie("openReviews", prodID, { path: '/' });
        // console.log('been set')
    })


    // PDP Tooltip Helper
    toolTip         = '.subscription-tooltip';
    toolTipCount    = 0;
    chker           = '';
    $(toolTip).on('touchstart mouseenter', function(e) {
        $el = $(this);
        e.preventDefault()
        toolTipCount++;
        clearTimeout(chker)
        if ( !$el.is('.hover') && toolTipCount == 1 ) {
            $el.addClass('hover');
        }
        if ( $el.is('.hover') && toolTipCount == 2 ) {
            $el.removeClass('hover');
            toolTipCount = 0;
        }
        chker = setTimeout(function () {
            if ( $(toolTip).is('.hover') ) {
                $el.removeClass('hover');
                toolTipCount = 0;
            }
        },5000)
        $(window).scroll(function () {
            $el.removeClass('hover');
            toolTipCount = 0;
        })
        // console.log('1: ',toolTipCount, e.type)
    }).on('blur mouseleave', function(e) {
        $el = $(this);
        e.preventDefault()
        $el.removeClass('hover');
        if ( e.type != 'blur' ) {
            $el.blur();
        }
        // console.log('2: ',toolTipCount, e.type)
        toolTipCount = 0;
    })

})



/* 
    Font Spy
*/
$(document).ready(function() {
    (function($) {
        $.fontSpy = function( element, conf ) {
            var $element = $(element),
                fontClean = $element.css("font-family");
            // Helps clear up when there's more than one family defined
            if ( fontClean.indexOf(',') > -1) {
                prevFontClean = fontClean;
                fontClean = prevFontClean.substr(0,prevFontClean.indexOf(','))
                // console.log($element,'\n\nCleaned: '+fontClean+'\n\nNormal: '+prevFontClean+'\n')
            }
            var defaults = {
                font: fontClean,
                onLoad: 'hideMe',
                onFail: 'font-is-wrong',
                testFont: 'Comic Sans MS',
                testString: 'QW@HhsXJ',
                delay: 50,
                timeOut: 5000
            };
            var config = $.extend( defaults, conf );
            var tester = document.createElement('span');
                tester.style.position = 'absolute';
                tester.style.top = '-9999px';
                tester.style.left = '-9999px';
                tester.style.visibility = 'hidden';
                tester.style.fontFamily = config.testFont;
                tester.style.fontSize = '250px';
                tester.innerHTML = config.testString;
            document.body.appendChild(tester);
            var fallbackFontWidth = tester.offsetWidth;
            tester.style.fontFamily = config.font + ',' + config.testFont;
            function checkFont() {
                var loadedFontWidth = tester.offsetWidth;
                if (fallbackFontWidth === loadedFontWidth){
                    if(config.timeOut < 0) {
                        $element.removeClass(config.onLoad);
                        $element.addClass(config.onFail);
                        console.log($element,'failure');
                    }
                    else {
                        $element.addClass(config.onLoad);
                        setTimeout(checkFont, config.delay);
                        config.timeOut = config.timeOut - config.delay;
                    }
                }
                else {
                    $element.removeClass(config.onLoad);
                }
            }
            checkFont();
        };
        $.fn.fontSpy = function(config) {
            return this.each(function() {
                if (undefined == $(this).data('fontSpy')) {
                    var plugin = new $.fontSpy(this, config);
                    $(this).data('fontSpy', plugin);
                }
            });
        };
    })(jQuery);

    // $('h2').fontSpy();
    // $('h3').fontSpy();
    // $('h4').fontSpy();
    // $('p').fontSpy();
    // $('span').fontSpy();
    // $('li').fontSpy();
    // $('a').fontSpy();
});



/* 
    GIFT CARD scroll to =>
    Scrolls to product if "gift_card" hash is present,
    Refactoring needed! Reason why a id couldn't be set for anchor tag usage
*/
$(window).on('load',function(){
    var scrollToHash = location.hash.substr(1);
    if(scrollToHash == "gift_card") {
        setTimeout(function () {
            var targetEle = document.querySelector("[data-handle='gift-card']"),
                eleY = targetEle.offsetTop;

            targetEle.scrollIntoView({ block: 'end',  behavior: 'smooth' })
            //console.log('Gift Card has been anchored to: ', eleY);
        },1500)
    }
});




/*  
    Helper Functions
*/
function handleExists(items, handle) {
    return items.some(function(item) {
        return item.handle === handle;
    }); 
}

function productExists(items, id) {
    return items.some(function(item) {
        return item.product_id === id;
    }); 
}

function variantExists(items, variant) {
    return items.some(function(item) {
        return item.id === variant;
    });
}

function normalizeVariantId(variant) {
    return Number(variant);
}

function lineHasDiscountProperty(item, discountProperty) {
    var props = item.properties || {};
    return props.Discount == discountProperty;
}

function findCartLineByVariantAndDiscount(items, variant, discountProperty) {
    variant = normalizeVariantId(variant);
    return items.find(function(item) {
        return normalizeVariantId(item.id) === variant && lineHasDiscountProperty(item, discountProperty);
    });
}

function getCartLinesByVariantAndDiscount(items, variant, discountProperty) {
    variant = normalizeVariantId(variant);
    return items.filter(function(item) {
        return normalizeVariantId(item.id) === variant && lineHasDiscountProperty(item, discountProperty);
    });
}

function getAutoPromoKey(variant, discountProperty) {
    return normalizeVariantId(variant) + ':' + discountProperty;
}

function autoPromoGiftQtyInCart(items, variant, discountProperty) {
    return getCartLinesByVariantAndDiscount(items, variant, discountProperty).reduce(function(sum, line) {
        return sum + line.quantity;
    }, 0);
}

function autoPromoGiftQueued(variant, discountProperty) {
    variant = normalizeVariantId(variant);
    if (!window.Shopify || !window.Shopify.queue) {
        return false;
    }
    return window.Shopify.queue.some(function(request) {
        return request.action === 'add' &&
            normalizeVariantId(request.data.id) === variant &&
            request.data.properties &&
            request.data.properties.Discount == discountProperty;
    });
}

function enforceAutoPromoGiftMaxQty(items, variant, maxQty, discountProperty) {
    var lines = getCartLinesByVariantAndDiscount(items, variant, discountProperty),
        totalQty = autoPromoGiftQtyInCart(items, variant, discountProperty);

    if (totalQty <= maxQty) {
        return;
    }

    var remaining = maxQty;

    lines.forEach(function(line) {
        if (remaining > 0) {
            var newQty = Math.min(line.quantity, remaining);
            remaining -= newQty;

            if (line.quantity !== newQty) {
                $.ajax({
                    url: '/cart/change.json',
                    type: 'post',
                    dataType: 'json',
                    data: {
                        id: line.key,
                        quantity: newQty
                    }
                });
            }
        } else {
            $.ajax({
                url: '/cart/change.json',
                type: 'post',
                dataType: 'json',
                data: {
                    id: line.key,
                    quantity: 0
                }
            });
        }
    });
}

function skuExists(items, sku) {
    return items.some(function(item) {
        return item.sku === sku;
    });
}

function findCommonProduct(arr1, arr2) {
    return arr1.some(function (item) {
        return arr2.includes(item);
    });
}

function findCommonSKU(arr1, arr2) {
    return arr1.some(function (item) {
      return arr2.includes(item);
    });
} 

function qtyExists(items, qty) {
    return items.some(function(item) {
        return item.quantity >= qty;
    });
}

function itemQtyExists(items, xItem, qty) {
    return items.some(function(item) {
        return item.id == xItem && item.quantity == qty;
    });
}


/*
    Add Product to cart =>
        Added with/without discount property
*/
function addToQueue(id, discountProperty) {
    if (id.toString().indexOf(',') > -1) {
        id.split(',').forEach(function(i) {
            addToQueue(i, discountProperty);
        });
    } else {
        window.Shopify.queue.push({
            action: 'add',
            data: {
                id: id,
                quantity: 1,
                properties: {
                    'Discount': discountProperty
                }
            }
        });
    }
};


/*
    Add Product to cart in QTY =>
        Added with/without discount property
*/
function addToQueueQTY(id, qty, discountProperty) {
    if (id.toString().indexOf(',') > -1) {
        id.split(',').forEach(function(i) {
            addToQueueQTY(i, qty, discountProperty);
        });
    } else {
        window.Shopify.queue.push({
            action: 'add',
            data: {
                id: id,
                quantity: qty,
                properties: {
                    'Discount': discountProperty
                }
            }
        });
    }
};


/*  
    Promotion: Custom Tiers (3) $20, $30, $40
        Use: customTiersJune_21(1st GWP variant id, 2nd GWP variant id, delay in milliseconds)
            Example: customTiersJune_21(46767011136,46767011139,500)
*/
function customTiersJune_21(var1, var2, delay) {
    var tier1 = 2000,
        tier2 = 3000,
        tier3 = 4000;

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items,
                total = cart.total_price;

            if(total >= tier3) {
                if(variantExists(items, var2) === false) {
                    console.log('%c' + var2 + ' was succesfully added (2)! (Over $30)', 'color:green;');
                    
                    addToQueueQTY(var2,2,'FREE GIFT!');
                    window.Shopify.moveAlong();
                } else if(itemQtyExists(items, var2, 2) === false) {
                    console.log('%c' + var2 + ' was succesfully added (1)! (Over $30)', 'color:green;');
                    
                    addToQueue(var2,'FREE GIFT!');
                    window.Shopify.moveAlong();
                } 
            }

            if(total >= tier2) {
                if(variantExists(items, var2) === false) {
                    console.log('%c' + var1 + ' was succesfully added (1)! (Over $30)', 'color:green;');
                    
                    addToQueue(var2,'FREE GIFT!');
                    window.Shopify.moveAlong();
                }
            }

            if(total >= tier1) {
                if(variantExists(items, var1) === false) {
                    console.log('%c' + var1 + ' was succesfully added (1)! (Over $20)', 'color:green;');
                    
                    addToQueue(var1,'FREE GIFT!');
                    window.Shopify.moveAlong();
                }
            }
        });
    }, delay) 

}


/* 
    Helper Function: GWP && Alternative GWP if stock is low => auto add GWP
        Use: addGWP(gwpHandle, checkQTY, altVariant, delay in milliseconds)
            Example: NEED TO RUN THROUGH THIS AGAIN... only works with single variant products right now ***
                Why am I doing this? 
*/
function addGWP(gwpHandle, checkQTY, altVariant, delay) {
    
    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items;

            if(handleExists(items, gwpHandle) === false) {
                $.getJSON('/products/' + gwpHandle, function (product) {
                    var product = product.product,
                        title = product.title,
                        variant = product.variants[0].id,
                        qty = product.variants[0].inventory_quantity;

                    if(qty < checkQTY) {
                        variant = altVariant;

                        if(variantExists(items, variant) === false) {
                            console.log(title + ' is low, adding alternative surprise gift.');

                            addToQueue(variant,"GWP");
                            window.Shopify.moveAlong();
                        }
                    } else {
                        addToQueue(variant,"GWP");
                        window.Shopify.moveAlong();
                    }
                });
            } 
        });
    }, delay);

}


/*  
    Promotion: Cart total over $X => auto add gift
        Use: cartTotalOverX_addGWP(minimum total, variant id, delay, discountProperty, maxQty)
            Example: cartTotalOverX_addGWP(3500, 41888663011425, 500, 'Discount', 1)
        discountProperty — line item properties.Discount value (default: 'Discount')
        maxQty — max units of this promo gift per cart (default: 1)
*/
window.autoPromoTimers = window.autoPromoTimers || {};
window._autoPromoGiftPending = window._autoPromoGiftPending || {};

function cartTotalOverX_addGWP(min, variant, delay, discountProperty, maxQty) {
    variant = normalizeVariantId(variant);
    discountProperty = discountProperty || 'Discount';
    maxQty = typeof maxQty === 'number' ? maxQty : 1;

    var promoKey = getAutoPromoKey(variant, discountProperty);

    clearTimeout(window.autoPromoTimers[promoKey]);

    window.autoPromoTimers[promoKey] = setTimeout(function() {
        if (window._autoPromoGiftPending[promoKey] || autoPromoGiftQueued(variant, discountProperty)) {
            return;
        }

        jQuery.getJSON('/cart.js', function(cart) {
            var items = cart.items,
                total = cart.total_price,
                promoQty = autoPromoGiftQtyInCart(items, variant, discountProperty);

            enforceAutoPromoGiftMaxQty(items, variant, maxQty, discountProperty);

            if (promoQty < maxQty && total >= min) {
                console.log(sessionStorage.getItem("discount"));
                console.log('%c' + variant + ' was succesfully added! (Over $X + GWP)', 'color:green;');

                window._autoPromoGiftPending[promoKey] = true;
                addToQueue(variant, discountProperty);
                window.Shopify.moveAlong(function() {
                    window._autoPromoGiftPending[promoKey] = false;
                });
            } else if (promoQty > 0 && total < min) {
                window._autoPromoGiftPending[promoKey] = false;
                getCartLinesByVariantAndDiscount(items, variant, discountProperty).forEach(function(line) {
                    $.ajax({
                        url: '/cart/change.json',
                        type: 'post',
                        dataType: 'json',
                        data: {
                            id: line.key,
                            quantity: 0
                        },
                        success: function() {
                            console.log('Gift removed.');
                        },
                        error: function(response) {
                            var errors = JSON.parse(response.responseText);
                            console.log(errors.errors);
                        }
                    });
                });
            }
        });
    }, delay);
}


/*  
    Promotion: Gift card value equal to or greater than $X => auto add $10 Gift Card
        Use: giftCardTotalOverX_addFreeGiftCard(minimum total, GWP variant id, delay in milliseconds)
            Example: giftCardTotalOverX_addFreeGiftCard(5000, 40605026910305, 1000)
*/
function giftCardTotalOverX_addFreeGiftCard(min, variant, delay) {

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items,
                cardTotal = 0,
                cards = items.filter(function(item) {
                    return item.product_type == "Gift Card"
                });

            if (variantExists(items, variant) == false && cards.length > 0) {
                for(var i = 0; i < cards.length; i++) {
                    cardTotal += cards[i].price; 
                }

                if(cardTotal >= min) {
                    console.log("");
                    console.log('%cPromo: Get free $10 Gift Card', 'color: #9c0814');
                    console.log("Gift Card Total:", cardTotal);
                    console.log("Gift Card Items:", cards);
                    console.log("Status: has gift cards AND is >= min!");
                    console.log("Action: Add free gift card!");
                    console.log("");

                    $.ajax({
                        url: '/cart/add.json',
                        type: 'post',
                        dataType: 'json',
                        data: {
                            quantity: 1,
                            id: variant
                        },
                        success: function(response) {
                            console.log('');
                            console.log('%c' + response.title + "%c was added to cart. (Over $X + GWP)", 'color: green','color: black',);
    

                        },
                        error: function(response) {
                            var errors = JSON.parse(response.responseText);
                            console.log(errors.errors);
                        }
                    });
                } else {
                    console.log("");
                    console.log('%cPromo: Get free $10 Gift Card', 'color: #9c0814');
                    console.log("Status: has gift cards BUT is not >= min!");
                    console.log("Action: No free gift card.");
                    console.log("");
                }
            } else {
                console.log("");
                console.log('%cPromo: Get free $10 Gift Card', 'color: #9c0814');
                console.log('Status: Free Gift Card already in cart OR there are no gift cards in cart!');
                console.log("");
            }

        });
    }, delay) 

}


/*  
    Promotion: Cart total over $X => auto add GWP
        Use: cartTotalOverX_addGWP(minimum total, GWP variant id, delay in milliseconds)
            Example: cartTotalOverX_addGWP(2500,46767011139,500)
*/
function cartTotalOverX_addMysteryGift(min, productHandle, delay) {

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items,
                total = cart.total_price;

                if(total >= min) {

                    //console.log('%c' + variant + ' was succesfully added! (Over $X + GWP)', 'color:green;');
                    //addToQueue(productVariant);
                    //window.Shopify.moveAlong();

                    //console.log('');
                    //console.log('Cart is over $30!');
                    //console.log('');
                    //console.log(items);

                    // assign product id from product json
                    fetch("/products/" + productHandle + "?view=json")
                    .then((response) => response.json())
                    .then((data) => (this.product = data))
                    .then(function (data) {

                        if(productExists(items, data.id) === false) {
                            console.log('Mystery Gift does not exist in cart. Add it!');
                            console.log('');

                            for(var i=0; i < data.variants.length; i++) {
                                console.log(data.variants[i].title, data.variants[i].quantity);

                                if(data.variants[i].quantity > 50) {
                                    $.ajax({
                                        url: '/cart/add.json',
                                        type: 'post',
                                        dataType: 'json',
                                        data: {
                                            quantity: 1,
                                            id: data.variants[i].id
                                        },
                                        success: function(response) {
                                            console.log('');
                                            console.log('%c' + response.title + "%c was added to cart. (Over $X + GWP)", 'color: green','color: black',);
                        

                                        },
                                        error: function(response) {
                                            var errors = JSON.parse(response.responseText);
                                            console.log(errors.errors);
                                        }
                                    });

                                    break;
                                }
                            }

                        } else {
                            console.log('Mystery Gift does exist. Do not add!');
                        }

                    });
    
                }
        });
    }, delay) 

}


/*  
    Promotion: Add Free Gift if Discount Code exists
*/
function addFreeGiftIfCode(code, variant, delay) {

    if (
        !!sessionStorage.getItem("discount") &&
        sessionStorage.getItem("discount").length != 0 &&
        sessionStorage.getItem("discount") == code
    ) {
        console.log('Code is present!')

        setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) { 
                var items = cart.items;
    
                if(variantExists(items, variant) === false) {
                    console.log('%c' + variant + ' was succesfully added!)', 'color:green;');
                    
                    //addToQueue(variant,'FREE GIFT!');
                    addToQueue(variant);
                    window.Shopify.moveAlong();
                }
            });
        }, delay);
    } else {
        console.log('Code not present.')
    }

}


/*  
    Promotion: Cart total over $X => pop up bb flops
        Use: cartTotalOverX_popUpFlops(minimum total, GWP variant id, delay in milliseconds)
            Example: cartTotalOverX_popUpFlops(2500,372673628162,500)
*/
function cartTotalOverX_popUpFlops(min, delay) {

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items,
                total = cart.total_price,
                flops = [39482693681249, 39482693714017, 39482693746785, 39482693779553],
                has = false;

                if(total >= min) {
                    for(i=0; i < flops.length; i++ ) {
                        if(variantExists(items, flops[i]) === true) {
                            has = true;
                            break;
                        }
                    }

                    if(has == false) {
                        console.log(sessionStorage.getItem("discount"));
                        console.log('%c' + 'Cart over ' + min + '. Item was popped up!', 'color:green;');
                        console.log('Possible Session set?');
                    } else {
                        console.log('%c' + 'GWP already in cart.', 'color:#fc523a;');
                    }
                }
        });
    }, delay) 

}


/*  
    Promotion: Cart total over $X in tiers of X => auto add 2 GWP on every tier
        Use: cartTotalOverTier_add2GWP_onEveryTier(tier, array of GWP variant ids, delay in milliseconds)
            Example: cartTotalOverTier_add2GWP_onEveryTier(1000,[46767011139, 46767011140],500)

            STOPPED IN THE MIDDLE OF DEV. WILL COME BACK LATER IF NEEDED
*/
function cartTotalOverTier_add2GWP_onEveryTier(tier, variants, delay) {

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items,
                total = cart.total_price;
                itemsQTY = Math.trunc(total / tier); 

            // Check if cart total is greater than or == to tier
            if(total >= tier) {
                console.log('');
                console.log('%cMeets a tier (' + itemsQTY + ') requirement.', 'color: green;');
                console.log('');
            }
                // Need to check if free variants are already in cart

                    // Not in cart => add variants to cart according to tier
                    // if(variantExists(items, variant) === false && total >= min) {
                    //     console.log(sessionStorage.getItem("discount"));
                    //     console.log('%c' + variant + ' was succesfully added! (Over $X + GWP)', 'color:green;');
                        
                    //     addToQueue(variant,'FREE GIFT!');
                    //     window.Shopify.moveAlong();
                    // }

                    // Already in cart => update variants in cart according to tier



        });
    }, delay) 

}


/* 
    Promotion: Buy 2 of same Variant(any) => auto add GWP
        Use: buy2ofSameVariant_addGWP(GWP variant id, delay in milliseconds)
            Example: buy2ofSameVariant_addGWP(32456834547809, 500)
*/
function buy2ofSameVariant_addGWP(variant, delay) {

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items;

            if(variantExists(items, variant) === false && qtyExists(items, 2) === true) {
                console.log('%c' + variant + ' was succesfully added! (Buy2 + GWP)', 'color:green;');
                
                addToQueue(variant);
                window.Shopify.moveAlong();
            }
        });
    }, delay) 

}


/* 
    Promotion: Buy X of same SKU(specific) => auto add GWP
        Use: buyXofSKU_addGWP(sku, qty, Gift variant id, delay in milliseconds)
            Example: buyXofSKU_addGWP('BB8496', 3, 9676477507, 500)
*/
function buyXofSKU_addGWP(sku, qty, gwp, delay) {
    
    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items;

            if(variantExists(items, gwp) === false) {
                for(var item of items) {
                    if(item.sku == sku && item.quantity >= qty ) {
                        addToQueue(gwp);
                        window.Shopify.moveAlong();
                        break;  
                    }
                }
            } else {
                if(skuExists(items, sku) === false) {
                    $.ajax({
                        url: "/cart/change.json",
                        type: "post",
                        dataType: "json",
                        data: {
                            id: gwp,
                            quantity: 0
                        },
                        success: function (response) {
                            console.log("Gift removed.");
                        },
                        error: function (response) {
                            var errors = JSON.parse(response.responseText);
                            console.log(errors.errors);
                        },
                    });
                }
            }

        });
    }, delay) 

}


/* 
    Promotion: Add X items from any Promotional Products(specific) => auto add GWP
        Use: addXitemsFromProducts_addGWP(Promotional products array, qty, Gift variant id, delay in milliseconds)
            Example: addXitemsFromProducts_addGWP({[4859560820833,4482231763041,3324946563,4861410639969,4654066860129,73533882371,3325140803,       3290712899,3958973694049,4654073217121,3325524931,5309695555,4482370207841,3325632259,5309944195,3325444291,4859556167777,5309695555,4859556167777,4859560820833]},
            3, 32456834547809, 500);
*/
function addXitemsFromProducts_addGWP(products, qty, gwp, delay) {
    
    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var cartQTYCount = 0,
                items = cart.items,
                promoProducts = products; // products to check against

            if(variantExists(items, gwp) == false) {
                for(var item of items){
                    if(promoProducts.includes(item.product_id) == true) {
                        cartQTYCount = cartQTYCount + item.quantity;
                    }
                }

                if(cartQTYCount >= qty) {
                    console.log(cartQTYCount + ' promotional products present. Add GWP!');
                    addToQueue(gwp);
                    window.Shopify.moveAlong();
                }
            }
        });
    }, delay) 

}


/* 
    Promotion: Buy any 2 SKUs(pair specific) => auto add GWP
        Use: buyAnyTwoSKUsGetXFree(sku1, sku2, qty, Gift variant id, delay in milliseconds)
            Example: buyAnyTwoSKUsGetXFree('SET-2OZ-TEAL-V1', 'SET-2OZ-PINK-V1', 32456834547809, 500)
*/
function buyAnyTwoSKUsGetXFree(a, b, gwp, delay) {

    setTimeout(function() {
        jQuery.getJSON('/cart.js', function(cart) { 
            var items = cart.items;

            if(variantExists(items, gwp) === false) {
                if(skuExists(items, a) === true && skuExists(items, b) === true) {
                    addToQueue(gwp);
                    window.Shopify.moveAlong();
                } else {
                    console.log("");
                    console.log('NYNY GWP scenario not met.');
                    console.log("");
                }
            }
        });
    }, delay);

}


/*
    4th of July TIERS DISCOUNT $20, $40, $60
*/
function july4thTiers() {

    jQuery.getJSON('/cart.js', function(cart) { 
        var total = cart.total_price;
        $('#chk-out').prop('disabled', true);

        setTimeout(function() {
            if(total > 6000) {
                if(sessionStorage.getItem("discount") != 'JULY4THTIER25') {
                    window.location.replace("/cart?discount=JULY4THTIER25");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('#savings').html('You have $25 in savings at checkout!');
                }
                
            } else if (total > 4000) {
                if(sessionStorage.getItem("discount") != 'JULY4THTIER15') {
                    window.location.replace("/cart?discount=JULY4THTIER15");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('#savings').html('You have $15 in savings at checkout!');
                }

            } else if (total > 2000) {
                if(sessionStorage.getItem("discount") != 'JULY4THTIER5') {
                    window.location.replace("/cart?discount=JULY4THTIER5");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('#savings').html('You have $5 in savings at checkout!');
                }
                
            } else {
                $('#chk-out').prop('disabled', false);
                
            }
        }, 750);
    });

}


/*
    Labor Day TIERS DISCOUNT $20, $30, $40, $50
*/
function laborDayTiers() {

    jQuery.getJSON('/cart.js', function(cart) { 
        var total = cart.total_price;
        $('#chk-out').prop('disabled', true);

        setTimeout(function() {
            if(total > 5000) {
                if(sessionStorage.getItem("discount") != 'LABORDAYTIER20') {
                    window.location.replace("/cart?discount=LABORDAYTIER20");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $20 in savings at checkout!');
                }
                
            } else if (total > 4000) {
                if(sessionStorage.getItem("discount") != 'LABORDAYTIER15') {
                    window.location.replace("/cart?discount=LABORDAYTIER15");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $15 in savings at checkout!');
                }

            } else if (total > 3000) {
                if(sessionStorage.getItem("discount") != 'LABORDAYTIER10') {
                    window.location.replace("/cart?discount=LABORDAYTIER10");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $10 in savings at checkout!');
                }

            } else if (total > 2000) {
                if(sessionStorage.getItem("discount") != 'LABORDAYTIER5') {
                    window.location.replace("/cart?discount=LABORDAYTIER5");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $5 in savings at checkout!');
                }
                
            } else {
                $('#chk-out').prop('disabled', false);
                
            }
        }, 750);
    });

}


/*
    October 2021 TIERS DISCOUNT $20, $30, $40, $50
*/
function octoberTiers() {

    jQuery.getJSON('/cart.js', function(cart) { 
        var total = cart.total_price;
        $('#chk-out').prop('disabled', true);

        setTimeout(function() {
            if(total > 5000) {
                if(sessionStorage.getItem("discount") != 'OCT21BMSM20') {
                    window.location.replace("/cart?discount=OCT21BMSM20");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $20 in savings at checkout!');
                }
                
            } else if (total > 4000) {
                if(sessionStorage.getItem("discount") != 'OCT21BMSM15') {
                    window.location.replace("/cart?discount=OCT21BMSM15");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $15 in savings at checkout!');
                }

            } else if (total > 3000) {
                if(sessionStorage.getItem("discount") != 'OCT21BMSM10') {
                    window.location.replace("/cart?discount=OCT21BMSM10");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $10 in savings at checkout!');
                }

            } else if (total > 2000) {
                if(sessionStorage.getItem("discount") != 'OCT21BMSM5') {
                    window.location.replace("/cart?discount=OCT21BMSM5");
                } else {
                    $('#chk-out').prop('disabled', false);
                    // $('#savings').css('backgroundColor', '#fee014');
                    $('.discount-code-elem').html('You have $5 in savings at checkout!');
                }
                
            } else {
                $('#chk-out').prop('disabled', false);
                
            }
        }, 750);
    });

}